/* eslint-disable */
import React, { Component } from "react";
import $ from "jquery";

import Header from "../Layouts/Header";
import MenuSidebar from "../Layouts/MenuSidebar";
import { SketchPicker } from "react-color";
import reactCSS from "reactcss";
import { apiUrl, cmscontentURL, mediaUrl } from "../Config/Config";

import Select from "react-select";
import axios from "axios";
import {
  scrollToTopValidate,
  PageTitle,
  scrollToTop,
} from "../Helpers/SettingHelper";
import Addinputsimple from "./Addinputsimple";
import Addinputsimplebus from "./Addinputsimplebus";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import queryString from "query-string";
import { ShadowPicker } from "react-shadow-picker";
import { lang } from "../Helpers/lang";
import { toHaveAccessibleDescription } from "@testing-library/jest-dom/matchers";

class Setting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settings_id: "",
      settings_site_title: "",
      settings_from_name: "",
      settings_admin_email: "",
      settings_from_email: "",
      settings_mailpath: "",
      settings_company_address: "",
      settings_commission_percentage: "",
      settings_smtp_host: "",
      settings_smtp_user: "",
      settings_smtp_pass: "",
      settings_smtp_port: "",
      settings_username: "",
      settings_mobileno: "",
      settings_email_footer: "",
      settings_commision_amount: "",
      smtp_checked: false,
      Loading: false,
      drLoading: false,
      displayColorPicker: false,
      color: {
        r: "241",
        g: "112",
        b: "19",
        a: "1",
      },
      hexColor: "#f17013",
      settings_public_key: "",
      settings_product_key: "",
      settings_secret_key: "",
      stripe_live_checked: false,
      stripe_sandbox_checked: false,
      settings_embedcode: "",
      setting_goal_amount: "",
      settings_access_code: "",
      settings_result_access_code: [],
      settings_car_access_code: "",
      settings_bus_access_code: "",
      st_position_left: "",
      st_position_right: "",
      st_position_top: "",
      st_plugin_radius: "",
      st_plugin_height: "",
      st_dropdown_menu_radius: "",
      vechile_icon_size: "",
      st_position_bottom: "",
      domainSets: "",
      cardomainSets: "",
      busdomainSets: "",
      removeID: [],
      fonttype: [],
      selectedFont: "",
      fontvalue: "",
      //st_position_checked:true,
      st_bonus_provide_checked: true,
      st_outer_space_checked: true,
      extraChargesTestMode: true,
      st_position: "fixed",
      supporter_additional_fee: "",
      product_layout2_checked: true,
      product_layout3_checked: false,
      google_analystic_code: "",
      category_icons_yes: true,
      category_icons_no: false,
      header_cat_limit: 1,
      domain_count: "",
      faqmodelguest: "",
      faqmodeluser: "",
      faqmodelcompany: "",
      faqmodelrehab: "",
      selectedfaqmodeluserval: "",
      selectedfaqmodelguestval: "",
      selectedfaqmodelcompanyval: "",
      selectedfaqmodelrehabval: "",
      selectedfaqmodelguest: "",
      selectedfaqmodelcompany: "",
      selectedfaqmodelrehab: "",
      selectedfaqmodeluserval: "",
      ai_fine_tune_model_id: "",
      aichat_type: "text",
      aichat_key: "",
      dashboard_view: "",
      plugin_size: "",
      st_plugin_for: "",
      //display_tab:"",
      landing_page: "mainTab",
      standalone_ride_commission: "",
      company_created_ride_commission: "",
      user_invite_summary: "",
      driver_invite_summary: "",
      company_invite_summary: "",
      credit_point_benefits:"",
      ai_side_menu_width: "",
      st_aisidebar_collapsed_width: "",
      invite_summary: "",
      st_aisidebar_icon_width: "",
      primary_font: "",
      main_tab_font_size: "",
      menu_font_size: "",
      lineHeight: "",
      selectedFontVariant: "",
      st_varient_id: [],
      fontDetails: [],
      fontidSave: [],
      themeData : [],
			selTheme  : [],
			theme_id  : '',
			description  : '',
      pluginSizeDetails: [
        { value: "600", label: "600px" },
        { value: "700", label: "700px" },
        { value: "800", label: "800px" },
        { value: "900", label: "900px" },
        { value: "1000", label: "1000px" },
      ],
      selPluginSize: "",
      selPluginSizeVal: "",
      // shadow:"0 18px 21px 0 #000",

      shadows: {
        pluginShadow: "0px 24px 34px #0404052e",
		pluginInsideLeftShadow: "15px 0 20px -10px #9898983d",
		pluginInsideRightShadow: "-15px 0 20px -10px #9898983d",
		pluginInsideTopShadow: "0 15px 20px -10px #9898983d",
		pluginInsideBottomShadow: "0 -15px 20px -10px #9898983d",
        dashboardShadowGrid: "0 10px 21px 0 #0000001c",
        dashboardShadowList: "0 21px 21px 0 #0000001c",
        // sideMenu:"-2px 10px 15px #3434375e",
        // largeButton: "0 4px 18px 0 #0404052e",
        // pluginInset: "5px 0px 15px 0 #3434372b",
        // smallButton: '0 18px 21px 0 #000',
        textarea: "0 7px 10px -7px #04040422",
        shortcutMenu: "0px 3px 21px 0px #9f99995c",
        dropdownmenu: "0px 3px 21px 0px #9f99995c",
        shadowAISidebar: "1px 0px #0000000c",
        shadowListRow: "1px 0px #0000000c",
        shadowTableRow: "1px 0px #0000000c",
        shadowMapPopup: "-2px 10px 15px #3434375e",
        shadowLeftSidebar: "-2px 10px 15px #3434375e",
        shadowRightSidebar: "-2px 10px 15px #3434375e",
        shadowSearchDropdown: "-2px 10px 15px #3434375e",
        // sidePopup: '0 18px 21px 0 #000',
      },

      activeShadowType: "largeButton",
      st_plugin_left_space: 0,
      st_plugin_right_space: 0,
      st_short_form_plugin_width:0,
      st_plugin_top_space: 0,
      st_plugin_bottom_space: 0,
      st_vehicle_img_width: 0,
      st_vehicle_img_height: 0,
      driver_before_grace_time:0,
      driver_after_grace_time:0,
      driver_cancel_block_limit:0,
      datafeedrCategory:'Travel accessories',
      point_for_inviting_user: 0,
      point_for_inviting_driver: 0,
      point_for_inviting_company: 0,
      st_term_conditions: '',
      st_load_map: '',
      st_route_map: '',
      st_tracking_map: '',
      st_load_map_zoom: '',
      st_route_map_zoom: '',
      st_tracking_map_zoom: '',
      bookingTimingSel : '',
      bookingTimingVal : '',
      
      internationalFlightTimingSel : '',
      internationalFlightTimingVal : '',
      domesticTimingSel : '',
      domesticTimingVal : '',
      
      bookingTimingTooltip : '',
      internationalFlightTimingTooltip : '',
      domesticTimingTooltip : '',
     
      basePriceMiles : 0,
      pricePerMiles : 0,
      pricePerMinutes : 0,
      rideBookingFee : 0,
      localRideMaxMile : 0,
      bankAccVerifyAmt : 0,
      localRideBasePrice : 0,
      longRideBasePrice : 0,
      tollCharge : 0,
      localRidePerMin : 0,
      longRidePerMin : 0,
      localRidePerMile : 0,
      longRidePerMile : 0,
      mediumRideBasePrice:'',
			mediumRidePerMin:'',
			mediumRidePerMile:'',
			mediumRideMaxMiles:'',
			ultraLongRideBasePrice:'',
			ultraLongRidePerMin:'',
			ultraLongRidePerMile:'',
			ultraLongRideMaxMiles:'',
			longRideMaxMiles:'',
      localRideStopfee:'',
      mediumRideStopfee:'',
      longRideStopfee:'',
      extraUptoMins:'',
      extraPerMinCost:'',
      extraPerMileCost:'',
      ultraLongRideStopfee:'',
      cancellationHours : 0,
      cancellationChargeAmt : 0,
      cancellationChargeTypeSel: { value: 'Flat', label: 'Flat'},
      cancellationChargeType : 'Flat',
      earnedCreditPoint:0,
      extraCreditPoint:0,
      convertAmtToPoints:5,
      creditAmountByDoller:0,
      payment_info: '',
      airport_either_pts:'',
      airport_both_pts:'',

      editRideTimeLimitSel : '',
      editRideTimeLimitVal : '',
      invitePageImgName: '',
      invitePageImgPreview: '',
      invitePageImg: '',
      st_scalar_height:"",
      st_scalar_width:"",
      scalar_icon_name:"",
      scalar_icon_preview:"",
      old_scalar_img:"",
      scalar_icon:null,
      st_notif_max_height:"",
      st_page_title_btm_space:"",
      common_ride_info:"",

            
    };

    this.inputRef = React.createRef();
    var qs = require("qs");
    var admin_id = localStorage.getItem("admin_id");
    var postobject = {
      admin_id: admin_id,
    };

    axios
      .post(apiUrl + "adminpanel/adminsettings", qs.stringify(postobject))
      .then((res) => {
        if (res.data.results) {
          const formpayload = res.data.results;
         // console.log(formpayload.results_access, "adminsettings");

          const newShadows = {
            pluginShadow: formpayload.plugin_shadow,
			pluginInsideLeftShadow: formpayload.pluginInsideLeftShadow,
			pluginInsideRightShadow: formpayload.pluginInsideRightShadow,
			pluginInsideTopShadow: formpayload.pluginInsideTopShadow,
			pluginInsideBottomShadow: formpayload.pluginInsideBottomShadow,
            dashboardShadowGrid: formpayload.dashbordgrid_shadow,
            dashboardShadowList: formpayload.dashbordlist_shadow,
            // sideMenu:formpayload.sidemenu_shadow,
            shortcutMenu: formpayload.shortcut_menu_shadow,
            largeButton: formpayload.large_button_shadow,
            // pluginInset: formpayload.pluginInset_shadow,
            // smallButton: formpayload.small_button_shadow,
            // sidePopup: formpayload.side_popup_shadow,
            textarea: formpayload.textarea_shadow,
            dropdownmenu: formpayload.dropdown_menu,
            shadowAISidebar: formpayload.shadowAISidebar,
            shadowListRow: formpayload.shadowListRow,
            shadowTableRow: formpayload.shadowTableRow,
            shadowLeftSidebar: formpayload.shadowLeftSidebar,
            shadowRightSidebar: formpayload.shadowRightSidebar,
            shadowMapPopup: formpayload.shadowMapPopup,
            shadowSearchDropdown: formpayload.shadowSearchDropdown,
            
          };
          this.setState({st_scalar_height:formpayload.st_scalar_height !=0 ? formpayload.st_scalar_height : ''});
					this.setState({st_scalar_width:formpayload.st_scalar_width !=0 ? formpayload.st_scalar_width : ''});
					this.setState({old_scalar_img:formpayload.scalar_icon_image,scalar_icon_image: formpayload.scalar_icon_image});
          
          this.setState({ shadows: newShadows });
          this.setState({ settings_id: formpayload.settings_id });
          this.setState({
            settings_site_title: formpayload.settings_site_title,
          });
          this.setState({ settings_from_name: formpayload.settings_from_name });
          this.setState({
            settings_admin_email: formpayload.settings_admin_email,
          });
          this.setState({ shadow: formpayload.settings_shadow });
          this.setState({ inputValue: formpayload.settings_shadow });
          this.setState({
            settings_from_email: formpayload.settings_from_email,
          });
          this.setState({ settings_mailpath: formpayload.settings_mailpath });
          this.setState({
            settings_company_address: formpayload.settings_company_address,
          });
          this.setState({
            settings_commission_percentage:
              formpayload.settings_commission_percentage,
          });
          this.setState({ settings_smtp_host: formpayload.settings_smtp_host });
          this.setState({ settings_smtp_user: formpayload.settings_smtp_user });
          this.setState({ settings_smtp_pass: formpayload.settings_smtp_pass });
          this.setState({ settings_smtp_port: formpayload.settings_smtp_port });
          this.setState({ settings_username: formpayload.settings_username });
          this.setState({ settings_mobileno: formpayload.settings_mobileno });
          this.setState({
            settings_email_footer: formpayload.settings_email_footer,
          });
          this.setState({
            hexColor: formpayload.settings_site_background_color,
          });
          this.setState({
            settings_public_key: formpayload.settings_public_key,
          });
          this.setState({
            settings_product_key: formpayload.settings_product_key,
          });
          this.setState({
            setting_goal_amount: formpayload.setting_goal_amount,
          });
          this.setState({
            supporter_additional_fee: formpayload.supporter_additional_fee,
          });
          this.setState({
            settings_secret_key: formpayload.settings_secret_key,
          });
          this.setState({ settings_embedcode: formpayload.settings_embedcode });
          this.setState({ settings_access_code: formpayload.access_code });
          this.setState({ st_position_left: formpayload.st_position_left == 0 ? "10" : formpayload.st_position_left });
          this.setState({ st_position_right: formpayload.st_position_right == 0 ? "" : formpayload.st_position_right });
          this.setState({ st_position_top: formpayload.st_position_top == 0 ? "10" : formpayload.st_position_top });
          this.setState({ st_position_bottom: formpayload.st_position_bottom == 0 ? "10" : formpayload.st_position_bottom });
          this.setState({ st_plugin_radius: formpayload.st_plugin_radius });
          this.setState({ st_plugin_height: formpayload.st_plugin_height });
          this.setState({ vechile_icon_size: formpayload.vechile_icon_size });
          this.setState({ invite_summary: formpayload.invite_summary });
          this.setState({ payment_info: formpayload.payment_info ,earnedCreditPoint: formpayload.earnedCreditPoint,extraCreditPoint: formpayload.extraCreditPoint,creditAmountByDoller: formpayload.creditAmountByDoller, convertAmtToPoints: formpayload.convertAmtToPoints,airport_either_pts:formpayload.airport_either_pts,
      airport_both_pts:formpayload.airport_both_pts});
          this.setState({ st_term_conditions: formpayload.st_term_conditions });
          
          this.setState({
            st_dropdown_menu_radius: formpayload.st_dropdown_menu_radius,
          });
          this.setState({
            st_plugin_top_space: formpayload.st_plugin_top_space,
          });
          this.setState({
            st_plugin_bottom_space: formpayload.st_plugin_bottom_space,
          });
          this.setState({
            st_plugin_left_space: formpayload.st_plugin_left_space,
          });
          this.setState({
            st_plugin_right_space: formpayload.st_plugin_right_space,
          });
           this.setState({
            st_short_form_plugin_width: formpayload.st_short_form_plugin_width,
          });
          
          this.setState({ point_for_inviting_user: formpayload.point_for_inviting_user,point_for_inviting_company: formpayload.point_for_inviting_company,point_for_inviting_driver: formpayload.point_for_inviting_driver });
          this.setState({ domainSets: formpayload.domainSets });
          this.setState({ cardomainSets: formpayload.cardomainSets });
          this.setState({ busdomainSets: formpayload.busdomainSets });
          this.setState({
            settings_commision_amount: formpayload.settings_commision_amount,
          });
          this.setState({ header_cat_limit: formpayload.header_cat_limit });
          this.setState({
            invite_friends_perc: formpayload.invite_friends_perc,
          });
          this.setState({ domain_count: formpayload.domain_count });
          this.setState({ np_theme: formpayload.notification_popup_theme });
          this.setState({ dashboard_view: formpayload.dashboardview });
          //this.setState({plugin_size: formpayload.plugin_size});
          this.setState({ st_plugin_for: formpayload.st_plugin_for });
          //this.setState({display_tab: formpayload.display_tab});
          this.setState({ landing_page: formpayload.landing_page });
          this.setState({
            standalone_ride_commission:
              formpayload.standalone_ride_commission_for_plugin_owner,
          });
          this.setState({
            st_vehicle_img_width: formpayload.st_vehicle_img_width, st_vehicle_img_height: formpayload.st_vehicle_img_height,
          });
          this.setState({ driver_before_grace_time: formpayload.driver_before_grace_time });
          this.setState({ driver_after_grace_time: formpayload.driver_after_grace_time });
          this.setState({driver_cancel_block_limit :formpayload.driver_cancel_block_limit });
          this.setState({datafeedrCategory :formpayload.datafeedrCategory });
          this.setState({
            company_created_ride_commission:
              formpayload.company_created_ride_commission_for_plugin_owner,
          });
          this.setState({
            st_notif_max_height:formpayload.st_notif_max_height,
            st_page_title_btm_space:formpayload.st_page_title_btm_space,
            common_ride_info:formpayload.common_ride_info,
          });

          this.setState({ ai_side_menu_width: formpayload.ai_side_menu_width });
          this.setState({
            st_aisidebar_icon_width: formpayload.st_aisidebar_icon_width,
          });
          this.setState({
            st_aisidebar_collapsed_width:
              formpayload.st_aisidebar_collapsed_width,
          });
          this.setState({ primary_font: formpayload.primary_font });
          this.setState({ main_tab_font_size: formpayload.main_tab_font_size });
          this.setState({ menu_font_size: formpayload.menu_font_size });
          this.setState({ lineHeight: formpayload.lineHeight });

          this.setState({ user_invite_summary: formpayload.user_invite_summary });
          this.setState({ driver_invite_summary: formpayload.driver_invite_summary });
          this.setState({ company_invite_summary: formpayload.company_invite_summary });
          this.setState({ credit_point_benefits: formpayload.credit_point_benefits });
          this.setState({ st_load_map: formpayload.st_load_map });
          this.setState({ st_route_map: formpayload.st_route_map });
          this.setState({ st_tracking_map: formpayload.st_tracking_map });
          this.setState({ st_load_map_zoom: formpayload.st_load_map_zoom });
          this.setState({ st_route_map_zoom: formpayload.st_route_map_zoom });
          this.setState({ st_tracking_map_zoom: formpayload.st_tracking_map_zoom });

          this.setState({ bookingTimingSel: { value: formpayload.bookingTiming, label: formpayload.bookingTiming }, bookingTimingVal : formpayload.bookingTiming, bookingTimingTooltip : formpayload.bookingTimingTooltip ? formpayload.bookingTimingTooltip : '' });
          this.setState({ internationalFlightTimingSel: { value: formpayload.internationalFlightTiming, label: formpayload.internationalFlightTiming }, internationalFlightTimingVal : formpayload.internationalFlightTiming, internationalFlightTimingTooltip : formpayload.internationalFlightTimingTooltip ? formpayload.internationalFlightTimingTooltip : '' });
          this.setState({ domesticTimingSel: { value: formpayload.domesticFlightTiming, label: formpayload.domesticFlightTiming }, domesticTimingVal : formpayload.domesticFlightTiming, domesticTimingTooltip : formpayload.domesticTimingTooltip ? formpayload.domesticTimingTooltip : '' });
         
          this.setState({ basePriceMiles: formpayload.basePriceMiles, bankAccVerifyAmt : formpayload.bankAccVerifyAmt, pricePerMinutes : formpayload.pricePerMinutes, pricePerMiles: formpayload.pricePerMiles, rideBookingFee : formpayload.rideBookingFee, localRideMaxMile: formpayload.localRideMaxMile });
           
          this.setState({ localRideBasePrice: formpayload.localRideBasePrice, longRideBasePrice: formpayload.longRideBasePrice, tollCharge : formpayload.tollCharge, localRidePerMin : formpayload.localRidePerMin, longRidePerMin: formpayload.longRidePerMin, localRidePerMile : formpayload.localRidePerMile, longRidePerMile: formpayload.longRidePerMile, mediumRideBasePrice: formpayload.mediumRideBasePrice, mediumRidePerMin: formpayload.mediumRidePerMin, mediumRidePerMile: formpayload.mediumRidePerMile, mediumRideMaxMiles: formpayload.mediumRideMaxMiles, ultraLongRideBasePrice: formpayload.ultraLongRideBasePrice, ultraLongRidePerMin: formpayload.ultraLongRidePerMin, ultraLongRidePerMile: formpayload.ultraLongRidePerMile, ultraLongRideMaxMiles: formpayload.ultraLongRideMaxMiles,longRideMaxMiles: formpayload.longRideMaxMiles,localRideStopfee: formpayload.localRideStopfee,
            mediumRideStopfee: formpayload.mediumRideStopfee,longRideStopfee: formpayload.longRideStopfee,ultraLongRideStopfee: formpayload.ultraLongRideStopfee
            });
          this.setState({extraUptoMins:formpayload.extraUptoMins,extraPerMinCost:formpayload.extraPerMinCost,extraPerMileCost:formpayload.extraPerMileCost})
          this.setState({ cancellationChargeTypeSel: { value: formpayload.cancellationChargeType, label: formpayload.cancellationChargeType }, cancellationChargeType : formpayload.cancellationChargeType, cancellationChargeAmt : formpayload.cancellationChargeAmt, cancellationHours : formpayload.cancellationHours});
          this.setState({
            settings_result_access_code: formpayload.results_access,
          });

          this.setState({ editRideTimeLimitSel: { value: formpayload.editRideTimeLimit, label: formpayload.editRideTimeLimit }, editRideTimeLimitVal : formpayload.editRideTimeLimit});
          
          this.setState({ invitePageTitle: formpayload.invitePageTitle, invitePageDesc: formpayload.invitePageDesc, invitePageImg: formpayload.invitePageImg});
         

          //if (formpayload.plugin_size === '600') {
          this.setState({
            plugin_size: formpayload.plugin_size,
            selPluginSize: [
              {
                value: formpayload.plugin_size,
                label: formpayload.plugin_size,
              },
            ],
          });
          //}

          if (
            formpayload.settings_faq_user_model_id !== "null" &&
            formpayload.settings_faq_user_model_id !== ""
          ) {
            this.setState({
              selectedfaqmodeluser: {
                value: formpayload.settings_faq_user_model_id,
                label: formpayload.settings_faq_user_model_id,
              },
              selectedfaqmodeluserval: formpayload.settings_faq_user_model_id,
            });
          }
          if (
            formpayload.settings_faq_guest_model_id !== "null" &&
            formpayload.settings_faq_guest_model_id !== ""
          ) {
            this.setState({
              selectedfaqmodelguest: {
                value: formpayload.settings_faq_guest_model_id,
                label: formpayload.settings_faq_guest_model_id,
              },
              selectedfaqmodelguestval: formpayload.settings_faq_guest_model_id,
            });
          }
          if (
            formpayload.settings_faq_company_model_id !== "null" &&
            formpayload.settings_faq_company_model_id !== ""
          ) {
            this.setState({
              selectedfaqmodelcompany: {
                value: formpayload.settings_faq_company_model_id,
                label: formpayload.settings_faq_company_model_id,
              },
              selectedfaqmodelcompanyval:
                formpayload.settings_faq_company_model_id,
            });
          }
          if (
            formpayload.settings_faq_rehab_model_id !== "null" &&
            formpayload.settings_faq_rehab_model_id !== ""
          ) {
            this.setState({
              selectedfaqmodelrehab: {
                value: formpayload.settings_faq_rehab_model_id,
                label: formpayload.settings_faq_rehab_model_id,
              },
              selectedfaqmodelrehabval: formpayload.settings_faq_rehab_model_id,
            });
          }
          this.setState({
            aichat_type: formpayload.ai_model_type,
            aichat_key: formpayload.ai_model_key,
          });
          this.setState({
            ai_fine_tune_model_id: formpayload.ai_fine_tune_model_id,
          });

          if (formpayload.google_analystic_code !== "null") {
            this.setState({
              google_analystic_code: formpayload.google_analystic_code,
            });
          } else {
            this.setState({ google_analystic_code: "" });
          }

          if (formpayload.settings_mail_from_smtp === "1") {
            this.setState({ smtp_checked: true });
          } else {
            this.setState({ smtp_checked: false });
          }

          if (formpayload.enable_live === "1") {
            this.setState({
              stripe_live_checked: true,
              stripe_sandbox_checked: false,
            });
          } else {
            this.setState({
              stripe_sandbox_checked: true,
              stripe_live_checked: false,
            });
          }

          this.setState({ st_position: formpayload.st_plugin_position }, () => {
            if (formpayload.st_plugin_position == "absolute") {
              $(".d-height").removeClass("d-none");
            } else {
              $(".d-height").addClass("d-none");
            }
          });

          if (formpayload.st_plugin_outerspace === "mobilespaceadded") {
            this.setState({ st_outer_space_checked: true });
          } else {
            this.setState({ st_outer_space_checked: false });
          }
          if (formpayload.extraChargesTestMode == "true") {
            this.setState({ extraChargesTestMode: true });
          } else {
            this.setState({ extraChargesTestMode: false });
          }

          if (formpayload.bonus_provide === "yes") {
            this.setState({ st_bonus_provide_checked: true });
          } else {
            this.setState({ st_bonus_provide_checked: false });
          }

          if (formpayload.product_layout === "2") {
            this.setState({ product_layout2_checked: true });
            this.setState({ product_layout3_checked: false });
          } else {
            this.setState({ product_layout3_checked: true });
            this.setState({ product_layout2_checked: false });
          }

          if (formpayload.show_category_icons === "yes") {
            this.setState({ category_icons_yes: true });
            this.setState({ category_icons_no: false });
          } else {
            this.setState({ category_icons_no: true });
            this.setState({ category_icons_yes: false });
          }

          if (res.data.font !== "" && res.data.font !== null) {
            this.setselectedvalue(res.data.font);
          }
          if(res.data.themelist!== '' && res.data.themelist!== null){
            this.setselectedtheme(res.data.themelist);
          }
          if (
            res.data.fontvarientlist !== "" &&
            res.data.fontvarientlist !== null
          ) {
            this.setselectedvariants(res.data.fontvarientlist);
          }
          if (res.data.setting_font_varients.length > 0) {
            this.setState({ fontDetails: res.data.setting_font_varients });
          } else {
            this.setState({
              fontDetails: [
                {
                  index: Math.random(),
                  FontType: "",
                  FontId: "",
                  fontSize: "",
                  fontWeight: "",
                  letterSpacing: "",
                  lineHeight: "",
                  TopSpace: "",
                  BottomSpace: "",
                  varient_id: "",
                },
              ],
            });
          }
        }
      });

    axios
      .get(apiUrl + "font/getfont_name?admin_id=" + admin_id)

      .then((res) => {
        if (res.data.status == "success") {
          this.setState({
            fonttype: res.data.fontlist,
          });
        } else {
          //console.log("test")
        }
      });
    
      axios.get(apiUrl+'thememanagement/gettheme_name?admin_id='+admin_id).then(res => {
        if(res.data.status == 'success'){
          this.setState({
            themeData: res.data.themelist
          })
        }else{
          //console.log("test")
        }
      });
    this.myCallback();
    this.myCallback2();
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onEditorChange = this.onEditorChange.bind(this);
  }
  onEditorChange(evt) {
    console.log(evt.editor.getData());
    var callfunc = this;
    setTimeout(function () {
      callfunc.setState({
        consent_form_agree: evt.editor.getData(),
      });
    }, 1000);
  }

  handleInputChange(event) {
    const { name, type, value, checked } = event.target;
    this.setState({
      [name]: type === 'checkbox' ? checked : value,
    });
    if (name === "settings_mail_from_smtp") {
      this.setState({ smtp_checked: !this.state.smtp_checked });
    }
    if (name === "settings_enable_live") {
      this.setState({ stripe_live_checked: !this.state.stripe_live_checked });
      this.setState({
        stripe_sandbox_checked: !this.state.stripe_sandbox_checked,
      });
    }
    if (name === "settings_enable_sandbox") {
      this.setState({
        stripe_sandbox_checked: !this.state.stripe_sandbox_checked,
      });
      this.setState({ stripe_live_checked: !this.state.stripe_live_checked });
    }
    if (name === "product_layout") {
      this.setState({
        product_layout2_checked: !this.state.product_layout2_checked,
      });
      this.setState({
        product_layout3_checked: !this.state.product_layout3_checked,
      });
    }

    if (name === "category_icons") {
      this.setState({ category_icons_yes: !this.state.category_icons_yes });
      this.setState({ category_icons_no: !this.state.category_icons_no });
    }

    if (name === "drchrono_client_id") {
      this.setState({ yourclientid: value });
      this.setState({ dr_refresh_token: "" });
    }
    //  if(name === 'cancellation_fees_type_percentage'){
    // 	this.setState({cancellation_fees_type_percentage: !this.state.cancellation_fees_type_percentage});
    // 	this.setState({cancellation_fees_type_flat: !this.state.cancellation_fees_type_flat});
    // }

    // if(name === 'reschedule_fees_type_flat'){
    // 	this.setState({reschedule_fees_type_flat: !this.state.reschedule_fees_type_flat});
    // 	this.setState({reschedule_fees_type_percentage: !this.state.reschedule_fees_type_percentage});
    //  }
    //  if(name === 'reschedule_fees_type_percentage'){
    // 	this.setState({reschedule_fees_type_percentage: !this.state.reschedule_fees_type_percentage});
    // 	this.setState({reschedule_fees_type_flat: !this.state.reschedule_fees_type_flat});
    // }

    //   if(name === 'st_position'){
    //   	this.setState({st_position_checked: !this.state.st_position_checked});
    //   }
    if (name === "st_outer_space") {
      this.setState((prevState) => ({
        st_outer_space_checked: !prevState.st_outer_space_checked,
      }));
    }
    if (name == "extraChargesTestMode") {
      this.setState((prevState) => ({
        extraChargesTestMode: !prevState.extraChargesTestMode,
      }, () => {
        console.log("extraChargesTestMode", this.state.extraChargesTestMode);
      }));
    }
    if (name === "bonus_provide") {
      this.setState({
        st_bonus_provide_checked: !this.state.st_bonus_provide_checked,
      });
    }
  }

  handleChange = (r, selOption) => {
    if (r == "plugin_size") {
      this.setState({ selPluginSize: selOption });
      this.setState({ plugin_size: selOption.value });
    }
  };

  onChangeHandler=(r,event)=>{
    let reader = new FileReader();
    const file = event.target.files[0];
    reader.onloadend = () => {

      if(r == 'invitePageImg'){
        this.setState({
          invitePageImgName: file.name,
          invitePageImgPreview: reader.result,
          invitePageImg: file
        });
      }
      else if(r == 'scalar_icon'){
			  this.setState({
				scalar_icon_name: file.name,
				scalar_icon_preview: reader.result,
				scalar_icon: file,
				
			  });
			
			reader.readAsDataURL(file);
		}
      
    };
    reader.readAsDataURL(file);
  }

  componentDidMount() {
    var admin_id = localStorage.getItem("admin_id");
    axios
      .get(apiUrl + "adminpanel/getchatmodel?admin_id=" + admin_id)
      .then((res) => {
        if (res.data.status == "success") {
          this.setState({
            faqmodelguest: res.data.faqmodelguest,
            faqmodeluser: res.data.faqmodeluser,
            faqmodelbroker: res.data.faqmodelbroker,
            faqmodelrehab: res.data.faqmodelrehab,
            faqmodelcompany: res.data.faqmodelcompany,
          });
        }
      });

    const queryParameters = new URLSearchParams(window.location.search);
    const client_id = queryParameters.get("client_id");
    const code = queryParameters.get("code");

    document.title = PageTitle("Settings");
    if (localStorage.getItem("admin_id") === null) {
      this.props.history.push("/");
    }
    let body = document.querySelectorAll("body")[0];
    if (localStorage.getItem("admin_id")) {
      body.classList.remove("body-theme");
    } else {
      body.classList.add("body-theme");
    }
  }

  handleFormSubmit = () => {
    if (this.validateForm()) {
      this.setState({ Loading: true });

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const formPayload = this.state;

      var qs = require("qs");
      if (this.state.smtp_checked === true) {
        var settings_mail_from_smtp = "1";
      } else {
        settings_mail_from_smtp = "0";
      }
      if (this.state.stripe_live_checked === true) {
        var settings_enable_live = "1";
      } else {
        settings_enable_live = "0";
      }

      // if(this.state.st_position_checked === true){
      // 	var plugin_position = 'fixed';
      // }else{
      // 	 plugin_position = 'absolute';
      // }
      if (this.state.st_bonus_provide_checked === true) {
        var bonus_provide = "yes";
      } else {
        var bonus_provide = "no";
      }

      var fonttype;
      if (formPayload.selectedFont[0] == undefined) {
        fonttype = formPayload.selectedFont.value;
      } else {
        fonttype = formPayload.selectedFont[0].value;
      }
      if (this.state.st_outer_space_checked === true) {
        var plugin_outerspace = "mobilespaceadded";
      } else {
        var plugin_outerspace = "mobilespaceremoved";
      }
      if (this.state.extraChargesTestMode == true) {
        var extraChargesTestMode = true;
      } else {
        var extraChargesTestMode = false;
      }

      var product_layout = "";
      if (this.state.product_layout3_checked === true) {
        product_layout = "3";
      } else {
        product_layout = "2";
      }

      var show_category = "";
      if (this.state.category_icons_yes === true) {
        show_category = "yes";
      } else {
        show_category = "no";
      }

     	var themeId;
		if(formPayload.selTheme[0]==undefined){
			themeId = formPayload.selTheme.value;
		}else{
			themeId = formPayload.selTheme[0].value;
		}

      // var cancellation_fees_type = '';
      // if(this.state.cancellation_fees_type_flat === true){
      // 	cancellation_fees_type = 'flat';
      // }else{
      // 	cancellation_fees_type = 'percentage';
      // }

      // var reschedule_fees_type = '';
      // if(this.state.reschedule_fees_type_flat === true){
      // 	reschedule_fees_type = 'flat';
      // }else{
      // 	reschedule_fees_type = 'percentage';
      // }

      var postObject = {
        settings_id: formPayload.settings_id,
        settings_site_title: formPayload.settings_site_title,
        settings_from_name: formPayload.settings_from_name,
        settings_admin_email: formPayload.settings_admin_email,
        settings_from_email: formPayload.settings_from_email,
        settings_mailpath: formPayload.settings_mailpath,
        settings_company_address: formPayload.settings_company_address,
        settings_commission_percentage:
          formPayload.settings_commission_percentage,
        site_background: formPayload.hexColor,
        smtp_host: formPayload.settings_smtp_host,
        smtp_user: formPayload.settings_smtp_user,
        smtp_pass: formPayload.settings_smtp_pass,
        smtp_port: formPayload.settings_smtp_port,
        admin_user: formPayload.settings_username,
        admin_no: formPayload.settings_mobileno,
        settings_email_footer: formPayload.settings_email_footer,
        settings_mail_from_smtp: settings_mail_from_smtp,
        settings_public_key: formPayload.settings_public_key,
        settings_product_key: formPayload.settings_product_key,
        setting_goal_amount: formPayload.setting_goal_amount,
        supporter_additional_fee: formPayload.supporter_additional_fee,
        settings_secret_key: formPayload.settings_secret_key,
        settings_enable_live: settings_enable_live,
        st_position: formPayload.st_position,

        st_position_top:
          formPayload.st_position_top != "" ? formPayload.st_position_top : "",
        st_position_bottom:
          formPayload.st_position_bottom != ""
            ? formPayload.st_position_bottom
            : "",
        st_position_left:
          formPayload.st_position_left != ""
            ? formPayload.st_position_left
            : "",
        st_position_right:
          formPayload.st_position_right != ""
            ? formPayload.st_position_right
            : "",

        st_plugin_top_space:
          formPayload.st_plugin_top_space != ""
            ? formPayload.st_plugin_top_space
            : "",
        st_plugin_bottom_space:
          formPayload.st_plugin_bottom_space != ""
            ? formPayload.st_plugin_bottom_space
            : "",
        st_plugin_left_space:
          formPayload.st_plugin_left_space != ""
            ? formPayload.st_plugin_left_space
            : "",
        st_plugin_right_space:
          formPayload.st_plugin_right_space != ""
            ? formPayload.st_plugin_right_space
            : "",
        st_short_form_plugin_width:  formPayload.st_short_form_plugin_width != ""
            ? formPayload.st_short_form_plugin_width
            : "",
        st_term_conditions: formPayload.st_term_conditions,
        point_for_inviting_user: formPayload.point_for_inviting_user,
        point_for_inviting_company: formPayload.point_for_inviting_company,
        point_for_inviting_driver: formPayload.point_for_inviting_driver,
        

        vechile_icon_size: formPayload.vechile_icon_size != "" ? formPayload.vechile_icon_size : "",
        //st_plugin_radius: formPayload.st_plugin_radius,
        st_plugin_height:
        formPayload.st_plugin_height != "" ? formPayload.st_plugin_height : 0,
        //st_dropdown_menu_radius: formPayload.st_dropdown_menu_radius,
        font: fonttype,
        settings_commision_amount: formPayload.settings_commision_amount,
        google_analystic_code: formPayload.google_analystic_code,
        product_layout: product_layout,
        removeId: formPayload.removeID,
        show_category_icons: show_category,
        bonus_provide: bonus_provide,
        settings_faq_user_model_id: formPayload.selectedfaqmodeluserval,
        settings_faq_guest_model_id: formPayload.selectedfaqmodelguestval,
        settings_faq_rehab_model_id: formPayload.selectedfaqmodelrehabval,
        settings_faq_company_model_id: formPayload.selectedfaqmodelcompanyval,
        aichat_type: formPayload.aichat_type,
        aichat_key: formPayload.aichat_key,
        ai_fine_tune_model_id: formPayload.ai_fine_tune_model_id,
        np_theme: formPayload.np_theme,
        dashboardview: formPayload.dashboard_view,
        plugin_size: formPayload.plugin_size,
        st_plugin_for: formPayload.st_plugin_for,
        //display_tab: formPayload.display_tab,
        landing_page: formPayload.landing_page,
        standalone_ride_commission: formPayload.standalone_ride_commission,
        company_created_ride_commission:formPayload.company_created_ride_commission,
        ai_side_menu_width: formPayload.ai_side_menu_width,
        st_aisidebar_collapsed_width: formPayload.st_aisidebar_collapsed_width,
        st_aisidebar_icon_width: formPayload.st_aisidebar_icon_width,
        primary_font: formPayload.primary_font,
        main_tab_font_size: formPayload.main_tab_font_size,
        menu_font_size: formPayload.menu_font_size,
        //lineHeight: formPayload.lineHeight,
        st_varient_id: formPayload.st_varient_id,
        //fontDetails: JSON.stringify(formPayload.fontDetails),
        plugin_outerspace: plugin_outerspace,
        extraChargesTestMode: extraChargesTestMode,
        st_vehicle_img_width: formPayload.st_vehicle_img_width,
        st_vehicle_img_height: formPayload.st_vehicle_img_height,
        driver_before_grace_time: formPayload.driver_before_grace_time,
        driver_after_grace_time: formPayload.driver_after_grace_time,
        driver_cancel_block_limit:formPayload.driver_cancel_block_limit,
        datafeedrCategory:formPayload.datafeedrCategory,
        invite_summary: formPayload.invite_summary,
        user_invite_summary: formPayload.user_invite_summary,
        driver_invite_summary: formPayload.driver_invite_summary,
        company_invite_summary: formPayload.company_invite_summary,
        credit_point_benefits: formPayload.credit_point_benefits,
        earnedCreditPoint: formPayload.earnedCreditPoint,
        convertAmtToPoints: formPayload.convertAmtToPoints,
        airport_either_pts:formPayload.airport_either_pts,
        airport_both_pts:formPayload.airport_both_pts,
        extraCreditPoint: formPayload.extraCreditPoint,
        creditAmountByDoller: formPayload.creditAmountByDoller,
        payment_info: formPayload.payment_info,
        st_load_map: formPayload.st_load_map,
        st_route_map: formPayload.st_route_map,
        st_tracking_map: formPayload.st_tracking_map,
        st_load_map_zoom: formPayload.st_load_map_zoom,
        st_route_map_zoom: formPayload.st_route_map_zoom,
        st_tracking_map_zoom: formPayload.st_tracking_map_zoom,

        bookingTiming: formPayload.bookingTimingVal,
        bookingTimingTooltip: formPayload.bookingTimingTooltip,
        internationalFlightTiming: formPayload.internationalFlightTimingVal,
        internationalFlightTimingTooltip: formPayload.internationalFlightTimingTooltip,
        domesticFlightTiming: formPayload.domesticTimingVal,
        domesticTimingTooltip: formPayload.domesticTimingTooltip,
        basePriceMiles: formPayload.basePriceMiles,
        pricePerMiles: formPayload.pricePerMiles,
        pricePerMinutes: formPayload.pricePerMinutes,
        rideBookingFee: formPayload.rideBookingFee,
        localRideMaxMile: formPayload.localRideMaxMile,
        bankAccVerifyAmt: formPayload.bankAccVerifyAmt,   
          
        localRideBasePrice: formPayload.localRideBasePrice, 
        longRideBasePrice: formPayload.longRideBasePrice,
        tollCharge: formPayload.tollCharge,
        localRidePerMin: formPayload.localRidePerMin,
        longRidePerMin: formPayload.longRidePerMin,
        localRidePerMile: formPayload.localRidePerMile,
        longRidePerMile: formPayload.longRidePerMile,  
        mediumRideBasePrice:formPayload.mediumRideBasePrice,
        mediumRidePerMin:formPayload.mediumRidePerMin,
        mediumRidePerMile:formPayload.mediumRidePerMile,
        mediumRideMaxMiles:formPayload.mediumRideMaxMiles,
        ultraLongRideBasePrice:formPayload.ultraLongRideBasePrice,
        ultraLongRidePerMin:formPayload.ultraLongRidePerMin,
        ultraLongRidePerMile:formPayload.ultraLongRidePerMile,
        ultraLongRideMaxMiles:formPayload.ultraLongRideMaxMiles,
        longRideMaxMiles:formPayload.longRideMaxMiles, 
        localRideStopfee: formPayload.localRideStopfee,
        mediumRideStopfee: formPayload.mediumRideStopfee,
        longRideStopfee: formPayload.longRideStopfee,
        ultraLongRideStopfee: formPayload.ultraLongRideStopfee,
        cancellationChargeType: formPayload.cancellationChargeType,
        cancellationChargeAmt: formPayload.cancellationChargeAmt,
        cancellationHours: formPayload.cancellationHours,
        editRideTimeLimit: formPayload.editRideTimeLimitVal,

        //shadow: JSON.stringify(this.state.shadows),
        themeId:themeId,

        invitePageTitle:formPayload.invitePageTitle,
        invitePageDesc:formPayload.invitePageDesc,
        invitePageImg:formPayload.invitePageImg,
        st_scalar_height:formPayload.st_scalar_height,
				st_scalar_width:formPayload.st_scalar_width,
				old_scalar_img:formPayload.old_scalar_img,
        extraUptoMins:formPayload.extraUptoMins,
        extraPerMinCost:formPayload.extraPerMinCost,
        extraPerMileCost:formPayload.extraPerMileCost,
        st_notif_max_height:formPayload.st_notif_max_height,
        st_page_title_btm_space:formPayload.st_page_title_btm_space,
        common_ride_info:formPayload.common_ride_info,

      };

      let formData = new FormData();
      for (let k in postObject) {
        formData.append(k, postObject[k]);
      }
      /* 	var domains = formPayload.domainSets
				for(let i in domains){
					formData.append('domainName[]',domains[i]['domain_name'])
				} */

      var domains = formPayload.domainSets;

      for (let i in domains) {
        if (domains[i]["domain_id"] == "undefined") {
          formData.append("domainName[" + i + "][domain_id]", "null");
        } else if (
          domains[i]["domain_id"] !== undefined &&
          domains[i]["domain_id"] !== ""
        ) {
          formData.append(
            "domainName[" + i + "][domain_id]",
            domains[i]["domain_id"]
          );
        }

        formData.append(
          "domainName[" + i + "][domain_name]",
          domains[i]["domain_name"]
        );
        formData.getAll("domainName");
      }
      var scalar_icondata = formPayload.scalar_icon;
				formData.append('scalar_icon_image',scalar_icondata)
      axios
        .post(apiUrl + "adminpanel/settingsave", formData, config)
        .then((res) => {
          if (res.data.status === "success") {
            if (res.data.results) {
              this.setState({ Loading: false });
              const formpayload = res.data.results;
              $(".success_message").html(
                '<div class="status_sucess"><h3>' +
                  res.data.message +
                  "</h3></div>"
              );
              this.setState({ settings_id: formpayload.settings_id });
              this.setState({
                settings_site_title: formpayload.settings_site_title,
              });
              this.setState({
                settings_from_name: formpayload.settings_from_name,
              });
              this.setState({
                settings_admin_email: formpayload.settings_admin_email,
              });
              this.setState({
                settings_from_email: formpayload.settings_from_email,
              });
              this.setState({ settings_mailpath: formpayload.settings_mailpath });
              this.setState({
                settings_company_address: formpayload.settings_company_address,
              });
              this.setState({
                settings_commission_percentage:
                  formpayload.settings_commission_percentage,
              });
              this.setState({
                settings_smtp_host: formpayload.settings_smtp_host,
              });
              this.setState({
                settings_smtp_user: formpayload.settings_smtp_user,
              });
              this.setState({
                settings_smtp_pass: formpayload.settings_smtp_pass,
              });
              this.setState({
                settings_smtp_port: formpayload.settings_smtp_port,
              });
              this.setState({ settings_username: formpayload.settings_username });
              this.setState({ settings_mobileno: formpayload.settings_mobileno });
              this.setState({
                settings_email_footer: formpayload.settings_email_footer,
              });
              this.setState({
                hexColor: formpayload.settings_site_background_color,
              });
              this.setState({
                settings_public_key: formpayload.settings_public_key,
              });
              this.setState({
                settings_product_key: formpayload.settings_product_key,
              });
              this.setState({
                setting_goal_amount: formpayload.setting_goal_amount,
              });
              this.setState({
                supporter_additional_fee: formpayload.supporter_additional_fee,
              });
              this.setState({
                settings_secret_key: formpayload.settings_secret_key,
              });
              this.setState({
                settings_embedcode: formpayload.settings_embedcode,
              });
              this.setState({ settings_access_code: formpayload.access_code });
              this.setState({
                settings_result_access_code: formpayload.results_access,
              });
              this.setState({ st_position_left: formpayload.st_position_left });
              this.setState({ st_position_right: formpayload.st_position_right });
              this.setState({ st_position_top: formpayload.st_position_top });
              this.setState({ st_plugin_radius: formpayload.st_plugin_radius });
              this.setState({ st_plugin_height: formpayload.st_plugin_height });
              this.setState({ vechile_icon_size: formpayload.vechile_icon_size });
              this.setState({ invite_summary: formpayload.invite_summary });
              this.setState({ user_invite_summary: formpayload.user_invite_summary });
              this.setState({ driver_invite_summary: formpayload.driver_invite_summary });
              this.setState({ company_invite_summary: formpayload.company_invite_summary });
              this.setState({ credit_point_benefits: formpayload.credit_point_benefits });
              this.setState({ st_term_conditions: formpayload.st_term_conditions });
              this.setState({ payment_info: formpayload.payment_info ,earnedCreditPoint: formpayload.earnedCreditPoint,extraCreditPoint: formpayload.extraCreditPoint,creditAmountByDoller: formpayload.creditAmountByDoller, convertAmtToPoints: formpayload.convertAmtToPoints,airport_either_pts:formpayload.airport_either_pts,airport_both_pts:formpayload.airport_both_pts });

              this.setState({ st_load_map: formpayload.st_load_map });
              this.setState({ st_route_map: formpayload.st_route_map });
              this.setState({ st_tracking_map: formpayload.st_tracking_map });
              this.setState({ st_load_map_zoom: formpayload.st_load_map_zoom });
              this.setState({ st_route_map_zoom: formpayload.st_route_map_zoom });
              this.setState({ st_tracking_map_zoom: formpayload.st_tracking_map_zoom });
              this.setState({ bookingTimingSel: { value: formpayload.bookingTiming, label: formpayload.bookingTiming }, bookingTimingVal : formpayload.bookingTiming, bookingTimingTooltip : formpayload.bookingTimingTooltip ? formpayload.bookingTimingTooltip : '' });
              this.setState({ internationalFlightTimingSel: { value: formpayload.internationalFlightTiming, label: formpayload.internationalFlightTiming }, internationalFlightTimingVal : formpayload.internationalFlightTiming, internationalFlightTimingTooltip : formpayload.internationalFlightTimingTooltip ? formpayload.internationalFlightTimingTooltip : '' });
              this.setState({ domesticTimingSel: { value: formpayload.domesticFlightTiming, label: formpayload.domesticFlightTiming }, domesticTimingVal : formpayload.domesticFlightTiming, domesticTimingTooltip : formpayload.domesticTimingTooltip ? formpayload.domesticTimingTooltip : '' });
              this.setState({ cancellationChargeTypeSel: { value: formpayload.cancellationChargeType, label: formpayload.cancellationChargeType }, cancellationChargeType : formpayload.cancellationChargeType, cancellationChargeAmt : formpayload.cancellationChargeAmt, cancellationHours : formpayload.cancellationHours});

              this.setState({ editRideTimeLimitSel: { value: formpayload.editRideTimeLimit, label: formpayload.editRideTimeLimit }, editRideTimeLimitVal : formpayload.editRideTimeLimit});
              this.setState({ invitePageTitle: formpayload.invitePageTitle, invitePageDesc: formpayload.invitePageDesc, invitePageImg: formpayload.invitePageImg});
              
              this.setState({
                st_dropdown_menu_radius: formpayload.st_dropdown_menu_radius,
              });
              this.setState({
                st_position_bottom: formpayload.st_position_bottom,
              });

              this.setState({
                st_plugin_top_space: formpayload.st_plugin_top_space,
              });
              this.setState({
                st_plugin_bottom_space: formpayload.st_plugin_bottom_space,
              });
              this.setState({
                st_plugin_left_space: formpayload.st_plugin_left_space,
              });
              this.setState({
                st_plugin_right_space: formpayload.st_plugin_right_space,
              });
                this.setState({
                st_short_form_plugin_width: formpayload.st_short_form_plugin_width,
              });
              
              this.setState({ point_for_inviting_user: formpayload.point_for_inviting_user, point_for_inviting_driver: formpayload.point_for_inviting_driver, point_for_inviting_company: formpayload.point_for_inviting_company });
              this.setState({ domainSets: formpayload.domainSets });
              this.setState({ cardomainSets: formpayload.cardomainSets });
              this.setState({ busdomainSets: formpayload.busdomainSets });
              this.setState({
                settings_commision_amount: formpayload.settings_commision_amount,
              });
              this.setState({
                merchant_commision_to_broker:
                  formpayload.merchant_commision_to_broker,
              });
              this.setState({
                rehab_purchase_count: formpayload.rehab_purchase_count,
              });
              this.setState({ header_cat_limit: formpayload.header_cat_limit });
              this.setState({ domain_count: formpayload.domain_count });
              this.setState({ np_theme: formpayload.notification_popup_theme });
              this.setState({ dashboard_view: formpayload.dashboardview });
              //	this.setState({display_tab: formpayload.display_tab});
              this.setState({ landing_page: formpayload.landing_page });
              this.setState({ plugin_size: formpayload.plugin_size });
              this.setState({ st_position: formpayload.st_plugin_position });
              this.setState({ st_plugin_for: formpayload.st_plugin_for });
              this.setState({
                standalone_ride_commission:
                  formpayload.standalone_ride_commission_for_plugin_owner,
              }); 
              this.setState({
                st_vehicle_img_width: formpayload.st_vehicle_img_width,
                st_vehicle_img_height: formpayload.st_vehicle_img_height,
                basePriceMiles: formpayload.basePriceMiles,
                pricePerMiles: formpayload.pricePerMiles,
                pricePerMinutes: formpayload.pricePerMinutes,
                rideBookingFee: formpayload.rideBookingFee,
                localRideMaxMile: formpayload.localRideMaxMile,
                bankAccVerifyAmt: formpayload.bankAccVerifyAmt,                
                localRideBasePrice: formpayload.localRideBasePrice, 
                longRideBasePrice: formpayload.longRideBasePrice,
                tollCharge: formpayload.tollCharge,
                localRidePerMin: formpayload.localRidePerMin,
                longRidePerMin: formpayload.longRidePerMin,
                localRidePerMile: formpayload.localRidePerMile,
                longRidePerMile: formpayload.longRidePerMile,
                mediumRideBasePrice: formpayload.mediumRideBasePrice,
                mediumRidePerMin: formpayload.mediumRidePerMin,
                mediumRidePerMile: formpayload.mediumRidePerMile, 
                mediumRideMaxMiles: formpayload.mediumRideMaxMiles,
                ultraLongRideBasePrice: formpayload.ultraLongRideBasePrice,
                ultraLongRidePerMin: formpayload.ultraLongRidePerMin,
                ultraLongRidePerMile: formpayload.ultraLongRidePerMile,
                ultraLongRideMaxMiles: formpayload.ultraLongRideMaxMiles,
                longRideMaxMiles: formpayload.longRideMaxMiles,
                localRideStopfee: formpayload.localRideStopfee,
                mediumRideStopfee: formpayload.mediumRideStopfee,
                longRideStopfee: formpayload.longRideStopfee,
                ultraLongRideStopfee: formpayload.ultraLongRideStopfee

              });
                this.setState({extraUptoMins:formpayload.extraUptoMins,extraPerMinCost:formpayload.extraPerMinCost,extraPerMileCost:formpayload.extraPerMileCost})

                this.setState({driver_before_grace_time: formpayload.driver_before_grace_time});
                this.setState({driver_after_grace_time: formpayload.driver_after_grace_time});
                this.setState({driver_cancel_block_limit :formPayload.driver_cancel_block_limit });
                this.setState({datafeedrCategory :formPayload.datafeedrCategory });
              this.setState({
                company_created_ride_commission:
                  formpayload.company_created_ride_commission_for_plugin_owner,
              });
               this.setState({
                st_notif_max_height:formpayload.st_notif_max_height,
                st_page_title_btm_space:formpayload.st_page_title_btm_space,
                common_ride_info:formpayload.common_ride_info,
              });

              this.setState({
                ai_side_menu_width: formpayload.ai_side_menu_width,
              });
              this.setState({
                st_aisidebar_collapsed_width:
                  formpayload.st_aisidebar_collapsed_width,
              });
              this.setState({
                st_aisidebar_icon_width: formpayload.st_aisidebar_icon_width,
              });
              this.setState({ primary_font: formpayload.primary_font });
              this.setState({
                main_tab_font_size: formpayload.main_tab_font_size,
              });
              this.setState({ menu_font_size: formpayload.menu_font_size });
              this.setState({ lineHeight: formpayload.lineHeight });

              if (
                formpayload.settings_faq_user_model_id !== "null" &&
                formpayload.settings_faq_user_model_id !== ""
              ) {
                this.setState({
                  selectedfaqmodeluser: {
                    value: formpayload.settings_faq_user_model_id,
                    label: formpayload.settings_faq_user_model_id,
                  },
                  selectedfaqmodeluserval: formpayload.settings_faq_user_model_id,
                });
              }
              if (
                formpayload.settings_faq_guest_model_id !== "null" &&
                formpayload.settings_faq_guest_model_id !== ""
              ) {
                this.setState({
                  selectedfaqmodelguest: {
                    value: formpayload.settings_faq_guest_model_id,
                    label: formpayload.settings_faq_guest_model_id,
                  },
                  selectedfaqmodelguestval:
                    formpayload.settings_faq_guest_model_id,
                });
              }
              if (
                formpayload.settings_faq_company_model_id !== "null" &&
                formpayload.settings_faq_company_model_id !== ""
              ) {
                this.setState({
                  selectedfaqmodelcompany: {
                    value: formpayload.settings_faq_company_model_id,
                    label: formpayload.settings_faq_company_model_id,
                  },
                  selectedfaqmodelcompanyval:
                    formpayload.settings_faq_company_model_id,
                });
              }
              if (
                formpayload.settings_faq_rehab_model_id !== "null" &&
                formpayload.settings_faq_rehab_model_id !== ""
              ) {
                this.setState({
                  selectedfaqmodelrehab: {
                    value: formpayload.settings_faq_rehab_model_id,
                    label: formpayload.settings_faq_rehab_model_id,
                  },
                  selectedfaqmodelrehabval:
                    formpayload.settings_faq_rehab_model_id,
                });
              }
              this.setState({
                aichat_type: formpayload.ai_model_type,
                aichat_key: formpayload.ai_model_key,
              });
              this.setState({
                ai_fine_tune_model_id: formpayload.ai_fine_tune_model_id,
              });

              if (formpayload.google_analystic_code !== "null") {
                this.setState({
                  google_analystic_code: formpayload.google_analystic_code,
                });
              } else {
                this.setState({ google_analystic_code: "" });
              }

              if (formpayload.settings_mail_from_smtp === "1") {
                this.setState({ smtp_checked: true });
              } else {
                this.setState({ smtp_checked: false });
              }

              if (formpayload.bonus_provide === "yes") {
                this.setState({ st_bonus_provide_checked: true });
              } else {
                this.setState({ st_bonus_provide_checked: false });
              }

              if (formpayload.product_layout === "2") {
                this.setState({ product_layout2_checked: true });
                this.setState({ product_layout3_checked: false });
              } else {
                this.setState({ product_layout3_checked: true });
                this.setState({ product_layout2_checked: false });
              }

              if (formpayload.enable_live === "1") {
                this.setState({ stripe_checked: true });
              } else {
                this.setState({ stripe_checked: false });
              }

              if (formpayload.show_category_icons === "yes") {
                this.setState({ category_icons_yes: true });
                this.setState({ category_icons_no: false });
              } else {
                this.setState({ category_icons_no: true });
                this.setState({ category_icons_yes: false });
              }
              scrollToTop();

              setTimeout(
                function () {
                  $(".success_message").html("");
                }.bind(this),
                3000
              );
            }
          }else{
            this.setState({ Loading: false });
             $(".success_message").html(
                '<div class="status_sucess"><h3>' +
                  res.data.message +
                  "</h3></div>"
              );
              scrollToTop();
              setTimeout(
                function () {
                  $(".success_message").html("");
                }.bind(this),
                3000
              );
          }
        });
    }
  };

  validateForm() {
    const {
      settings_commision_amount,
      settings_id,
      settings_site_title,
      settings_from_name,
      settings_admin_email,
      settings_from_email,
      settings_company_address,
      settings_commission_percentage,
      settings_smtp_host,
      settings_smtp_user,
      settings_smtp_pass,
      settings_smtp_port,
      settings_username,
      settings_mobileno,
      settings_email_footer,
      settings_public_key,
      settings_product_key,
      setting_goal_amount,
      supporter_additional_fee,
      settings_secret_key,
      settings_embedcode,
      selectedFont,
      payment_form,
      domainSets,
      busdomainSets,
      cardomainSets,
      primary_font,
      main_tab_font_size,
      menu_font_size,
      st_position,
      st_position_bottom,
      st_position_top,
      st_position_right,
      st_position_left,
      selTheme,
      bookingTimingTooltip,
      domesticTimingTooltip,
      internationalFlightTimingTooltip,
      basePriceMiles,
      bankAccVerifyAmt,
      st_notif_max_height
    } = this.state;
    // Allow only positive numbers (integer or decimal)
    const numberRegex = /^[0-9]+(\.[0-9]+)?$/;
    const nameRegex = /^[A-Za-z\s.]+$/;
    let errors = 0;
    const fontDetails = [...this.state.fontDetails];

    for (let index = 0; index < fontDetails.length; index++) {
      if (fontDetails[index].FontType == "") {
        fontDetails[index].FontTypeCheck = "Type is required";
        errors++;
      } else {
        fontDetails[index].FontTypeCheck = "";
      }
    }
    this.setState({ fontDetails });
    //let formIsValid = true;
    if (!settings_site_title) {
      errors++;
      $(".errorsettings_site_title").html(
        '<span class="errorspan">Please fill the field</span>'
      );
    } else if (settings_site_title) {
      if (!nameRegex.test(settings_site_title)) {
        errors++;
        $(".errorsettings_site_title").html(
          '<span class="errorspan">Please enter the valid site name</span>'
        );
      } else {
        $(".errorsettings_site_title").html("");
      }
    }
    if (!domainSets.length > 0) {
      errors++;
      $(".errorsettings_domain").html(
        '<span class="errorspan">Please add atleast one domain</span>'
      );
    } else {
      $(".errorsettings_domain").html("");
    }
    if (!settings_from_name) {
      errors++;
      $(".errorsettings_from_name").html(
        '<span class="errorspan">Please fill the field</span>'
      );
    } else if (settings_from_name) {
      if (!nameRegex.test(settings_from_name)) {
        errors++;
        $(".errorsettings_from_name").html(
          '<span class="errorspan">Please enter the valid from name</span>'
        );
      } else {
        $(".errorsettings_from_name").html("");
      }
    }

    if (!settings_admin_email) {
      errors++;
      $(".errorsettings_admin_email").html(
        '<span class="errorspan">Please fill the field</span>'
      );
    } else if (settings_admin_email) {
      var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (reg.test(settings_admin_email)) {
        $(".errorsettings_admin_email").html("");
      } else {
        errors++;

        $(".errorsettings_admin_email").html(
          '<span class="errorspan">Please enter valid email address</span>'
        );
      }
    }
    if (!settings_from_email) {
      errors++;
      $(".errorsettings_from_email").html(
        '<span class="errorspan">Please fill the field</span>'
      );
    } else if (settings_from_email) {
      var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (reg.test(settings_from_email)) {
        $(".errorsettings_from_email").html("");
      } else {
        errors++;

        $(".errorsettings_from_email").html(
          '<span class="errorspan">Please enter valid email address</span>'
        );
      }
    }

    if (!settings_mobileno) {
      errors++;
      $(".errorsettings_mobileno").html(
        '<span class="errorspan">Please fill the field</span>'
      );
    } else if (settings_mobileno) {
      var pattern = /^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
      var indiapattern = /^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/;
      if (pattern.test(settings_mobileno)) {
        $(".errorsettings_mobileno").html("");
      } else if (indiapattern.test(settings_mobileno)) {
        $(".errorsettings_mobileno").html("");
      } else {
        errors++;

        $(".errorsettings_mobileno").html(
          '<span class="errorspan">Please enter valid contact</span>'
        );
      }
    }

    if (!settings_email_footer) {
      errors++;
      $(".errorsettings_email_footer").html(
        '<span class="errorspan">Please fill the field</span>'
      );
    } else if (settings_company_address) {
      $(".errorsettings_email_footer").html("");
    }
    if (!settings_public_key) {
      errors++;
      $(".errorsettings_public_key").html(
        '<span class="errorspan">Please fill the field</span>'
      );
    } else if (settings_public_key) {
      $(".errorsettings_public_key").html("");
    }

    // if (!settings_product_key) {
    // 	errors++;
    // 	$('.errorsettings_product_key').html('<span class="errorspan">Please fill the field</span>');
    // }else if(settings_product_key){
    // 	$('.errorsettings_product_key').html('');
    // }

    if (!settings_secret_key) {
      errors++;
      $(".errorsettings_secret_key").html(
        '<span class="errorspan">Please fill the field</span>'
      );
    } else if (settings_secret_key) {
      $(".errorsettings_secret_key").html("");
    }

    if (st_position == "fixed") {
      if (!st_position_top) {
        errors++;
        $(".errorsettings_st_position_top").html(
          '<span class="errorspan">Please fill the field</span>'
        );
      } else if (st_position_top) {
        $(".errorsettings_st_position_top").html("");
      }
      if (!st_position_bottom) {
        errors++;
        $(".errorsettings_st_position_bottom").html(
          '<span class="errorspan">Please fill the field</span>'
        );
      } else if (st_position_bottom) {
        $(".errorsettings_st_position_bottom").html("");
      }
      if (!st_position_left && !st_position_right) {
        errors++;
        $(".errorsettings_st_position_left").html(
          '<span class="errorspan">Please enter either the left or right field.</span>'
        );
      } else if (st_position_left && st_position_right) {
        errors++;
        $(".errorsettings_st_position_left").html(
          '<span class="errorspan">Please enter either the left or right field.</span>'
        );
      } else {
        $(".errorsettings_st_position_left").html("");
      }
    } else if (st_position == "absolute") {
      if (!st_position_top && !st_position_bottom) {
        errors++;
        $(".errorsettings_st_position_top").html(
          '<span class="errorspan">Please enter either the top or bottom field.</span>'
        );
      } else if (st_position_top && st_position_bottom) {
        errors++;
        $(".errorsettings_st_position_top").html(
          '<span class="errorspan">Please enter either the top or bottom field.</span>'
        );
      } else {
        $(".errorsettings_st_position_top").html("");
      }

      if (!st_position_left && !st_position_right) {
        errors++;
        $(".errorsettings_st_position_left").html(
          '<span class="errorspan">Please enter either the left or right field.</span>'
        );
      } else if (st_position_left && st_position_right) {
        errors++;
        $(".errorsettings_st_position_left").html(
          '<span class="errorspan">Please enter either the left or right field.</span>'
        );
      } else {
        $(".errorsettings_st_position_left").html("");
      }
    }    

    if(!selTheme || selTheme.length == 0){
      errors++;
      $('.errortheme').html('<span class="errorspan">Please select the theme.</span>');
    }else{
      if(selTheme.value == 0 || selTheme.value == ''){
        errors++;
        $('.errortheme').html('<span class="errorspan">Please select the theme.</span>');
      } else{
        $('.errortheme').html('');
      }
	  }	
    if(!bookingTimingTooltip){
      errors++;
      $('.error_bookingTimingTooltip').html('<span class="errorspan">Please enter the tooltip message.</span>');
    }else{
      $('.error_bookingTimingTooltip').html('');     
	  }	
    if(!internationalFlightTimingTooltip){
      errors++;
      $('.error_internationalFlightTimingTooltip').html('<span class="errorspan">Please enter the tooltip message.</span>');
    }else{
      $('.error_internationalFlightTimingTooltip').html('');     
	  }	
    if(!domesticTimingTooltip){
      errors++;
      $('.error_domesticTimingTooltip').html('<span class="errorspan">Please enter the tooltip message.</span>');
    }else{
      $('.error_domesticTimingTooltip').html('');     
	  }	

    // if (!basePriceMiles) {
    //   errors++;
    //   $('.errorbasePriceMiles').html('<span class="errorspan">Please enter the field</span>');
    // } else if (!numberRegex.test(basePriceMiles) || Number(basePriceMiles) <= 0) {
    //   errors++;
    //   $('.errorbasePriceMiles').html('<span class="errorspan">Please enter a valid price</span>');
    // } else {
    //   $('.errorbasePriceMiles').html('');
    // }

    if (!bankAccVerifyAmt) {
      errors++;
      $('.errorbankAccVerifyAmt').html('<span class="errorspan">Please enter the field.</span>');
    } else if (!numberRegex.test(bankAccVerifyAmt) || Number(bankAccVerifyAmt) <= 0) {
      errors++;
      $('.errorbankAccVerifyAmt').html('<span class="errorspan">Please enter a valid amount</span>');
    } else {
      $('.errorbankAccVerifyAmt').html('');
    }

    if (errors > 0) {
      setTimeout(function () {
        scrollToTopValidate();
      }, 100);
      return false;
    } else {
      return true;
    }
  }

  componentWillReceiveProps(Props) {
    if (Props.updatesetting !== this.props.updatesetting) {
      if (Object.keys(Props.updatesetting).length > 0) {
        this.setState({ Loading: false });

        const formpayload = Props.updatesetting[0].results;
        console.log(formpayload, "thisis for formpayload");
        $(".success_message").html(
          '<div class="status_sucess"><h3>' +
            Props.updatesetting[0].message +
            "</h3></div>"
        );
        this.setState({
          fontDetails: Props.updatesetting[0].setting_font_varients,
        });
        this.setState({ settings_id: formpayload.settings_id });
        this.setState({ settings_site_title: formpayload.settings_site_title });
        this.setState({ settings_from_name: formpayload.settings_from_name });
        this.setState({
          settings_admin_email: formpayload.settings_admin_email,
        });
        this.setState({ settings_from_email: formpayload.settings_from_email });
        this.setState({ settings_mailpath: formpayload.settings_mailpath });
        this.setState({
          settings_company_address: formpayload.settings_company_address,
        });
        this.setState({
          settings_commission_percentage:
            formpayload.settings_commission_percentage,
        });
        this.setState({ settings_smtp_host: formpayload.settings_smtp_host });
        this.setState({ settings_smtp_user: formpayload.settings_smtp_user });
        this.setState({ settings_smtp_pass: formpayload.settings_smtp_pass });
        this.setState({ settings_smtp_port: formpayload.settings_smtp_port });
        this.setState({ settings_username: formpayload.settings_username });
        this.setState({ settings_mobileno: formpayload.settings_mobileno });
        this.setState({
          settings_email_footer: formpayload.settings_email_footer,
        });
        this.setState({ hexColor: formpayload.settings_site_background_color });
        this.setState({ settings_public_key: formpayload.settings_public_key });
        this.setState({
          settings_product_key: formpayload.settings_product_key,
        });
        this.setState({ setting_goal_amount: formpayload.setting_goal_amount });
        this.setState({
          supporter_additional_fee: formpayload.supporter_additional_fee,
        });
        this.setState({ settings_secret_key: formpayload.settings_secret_key });
        this.setState({ settings_embedcode: formpayload.settings_embedcode });
        this.setState({ settings_access_code: formpayload.access_code });
        this.setState({
          settings_result_access_code: formpayload.results_access,
        });
        this.setState({ st_position_left: formpayload.st_position_left });
        this.setState({ st_position_right: formpayload.st_position_right });
        this.setState({ st_position_top: formpayload.st_position_top });
        this.setState({ st_position_bottom: formpayload.st_position_bottom });
        this.setState({ invite_summary: formpayload.invite_summary });
        this.setState({ payment_info: formpayload.payment_info ,earnedCreditPoint: formpayload.earnedCreditPoint,extraCreditPoint: formpayload.extraCreditPoint,creditAmountByDoller: formpayload.creditAmountByDoller, convertAmtToPoints: formpayload.convertAmtToPoints,airport_either_pts:formpayload.airport_either_pts,airport_both_pts:formpayload.airport_both_pts  });

        this.setState({ st_term_conditions: formpayload.st_term_conditions });

        this.setState({ st_plugin_top_space: formpayload.st_plugin_top_space });
        this.setState({
          st_plugin_bottom_space: formpayload.st_plugin_bottom_space,
        });
        this.setState({
          st_plugin_left_space: formpayload.st_plugin_left_space,
        });
        this.setState({
          st_plugin_right_space: formpayload.st_plugin_right_space,
        });
        this.setState({
          st_short_form_plugin_width: formpayload.st_short_form_plugin_width,
        });
        

        this.setState({ point_for_inviting_user: formpayload.point_for_inviting_user, point_for_inviting_driver: formpayload.point_for_inviting_driver, point_for_inviting_company: formpayload.point_for_inviting_company });
        this.setState({ domainSets: formpayload.domainSets });
        this.setState({ busdomainSets: formpayload.busdomainSets });
        this.setState({ cardomainSets: formpayload.cardomainSets });
        this.setState({
          settings_commision_amount: formpayload.settings_commision_amount,
        });
        this.setState({ header_cat_limit: formpayload.header_cat_limit });
        this.setState({ domain_count: formpayload.domain_count });
        this.setState({ np_theme: formpayload.notification_popup_theme });
        this.setState({ dashboard_view: formpayload.dashboardview });
        this.setState({ plugin_size: formpayload.plugin_size });
        this.setState({ st_plugin_for: formpayload.st_plugin_for });
        //this.setState({display_tab: formpayload.display_tab});
        this.setState({ landing_page: formpayload.landing_page });
        this.setState({
          standalone_ride_commission:
            formpayload.standalone_ride_commission_for_plugin_owner,
        });
        this.setState({
          st_vehicle_img_width: formpayload.st_vehicle_img_width,
          st_vehicle_img_height: formpayload.st_vehicle_img_height,
          basePriceMiles: formpayload.basePriceMiles,
          pricePerMiles: formpayload.pricePerMiles,
          pricePerMinutes: formpayload.pricePerMinutes,
          rideBookingFee: formpayload.rideBookingFee,
          localRideMaxMile: formpayload.localRideMaxMile,
          bankAccVerifyAmt: formpayload.bankAccVerifyAmt,

           
          localRideBasePrice: formpayload.localRideBasePrice, 
          longRideBasePrice: formpayload.longRideBasePrice,
          tollCharge: formpayload.tollCharge,
          localRidePerMin: formpayload.localRidePerMin,
          longRidePerMin: formpayload.longRidePerMin,
          localRidePerMile: formpayload.localRidePerMile,
          longRidePerMile: formpayload.longRidePerMile,
          mediumRideBasePrice: formpayload.mediumRideBasePrice,
          mediumRidePerMin: formpayload.mediumRidePerMin,
          mediumRidePerMile: formpayload.mediumRidePerMile, 
          mediumRideMaxMiles: formpayload.mediumRideMaxMiles,
          ultraLongRideBasePrice: formpayload.ultraLongRideBasePrice,
          ultraLongRidePerMin: formpayload.ultraLongRidePerMin,
          ultraLongRidePerMile: formpayload.ultraLongRidePerMile,
          ultraLongRideMaxMiles: formpayload.ultraLongRideMaxMiles,
          longRideMaxMiles: formpayload.longRideMaxMiles,
          localRideStopfee: formpayload.localRideStopfee,
          mediumRideStopfee: formpayload.mediumRideStopfee,
          longRideStopfee: formpayload.longRideStopfee,
          ultraLongRideStopfee: formpayload.ultraLongRideStopfee

        });
        this.setState({driver_before_grace_time: formpayload.driver_before_grace_time});  
        this.setState({driver_after_grace_time: formpayload.driver_after_grace_time});
        this.setState({driver_cancel_block_limit:formpayload.driver_cancel_block_limit});
        this.setState({datafeedrCategory:formpayload.datafeedrCategory});
        this.setState({
          company_created_ride_commission:
            formpayload.company_created_ride_commission_for_plugin_owner,
        });
        this.setState({
          st_notif_max_height:formpayload.st_notif_max_height,
          st_page_title_btm_space:formpayload.st_page_title_btm_space,
          common_ride_info:formpayload.common_ride_info,
        });
        this.setState({ ai_side_menu_width: formpayload.ai_side_menu_width });
        this.setState({
          st_aisidebar_collapsed_width:
            formpayload.st_aisidebar_collapsed_width,
        });
        this.setState({
          st_aisidebar_icon_width: formpayload.st_aisidebar_icon_width,
        });
        this.setState({ st_position: formpayload.st_plugin_position }, () => {
          if (formpayload.st_plugin_position == "absolute") {
            $(".d-height").removeClass("d-none");
          } else {
            $(".d-height").addClass("d-none");
          }
        });

        if (formpayload.google_analystic_code !== "null") {
          this.setState({
            google_analystic_code: formpayload.google_analystic_code,
          });
        } else {
          this.setState({ google_analystic_code: "" });
        }

        if (formpayload.settings_mail_from_smtp === "1") {
          this.setState({ smtp_checked: true });
        } else {
          this.setState({ smtp_checked: false });
        }

        if (formpayload.bonus_provide === "yes") {
          this.setState({ st_bonus_provide_checked: true });
        } else {
          this.setState({ st_bonus_provide_checked: false });
        }

        if (formpayload.product_layout === "2") {
          this.setState({ product_layout2_checked: true });
          this.setState({ product_layout3_checked: false });
        } else {
          this.setState({ product_layout3_checked: true });
          this.setState({ product_layout2_checked: false });
        }

        if (formpayload.enable_live === "1") {
          this.setState({ stripe_checked: true });
        } else {
          this.setState({ stripe_checked: false });
        }

        if (formpayload.show_category_icons === "yes") {
          this.setState({ category_icons_yes: true });
          this.setState({ category_icons_no: false });
        } else {
          this.setState({ category_icons_no: true });
          this.setState({ category_icons_yes: false });
        }
        scrollToTop();

        setTimeout(
          function () {
            $(".success_message").html("");
          }.bind(this),
          3000
        );
      }
    }

    var admin_id = localStorage.getItem("admin_id");
    axios
      .get(apiUrl + "font/getfont_name?admin_id=" + admin_id)

      .then((res) => {
        if (res.data.status == "success") {
          this.setState({
            fonttype: res.data.fontlist,
          });
        } else {
          //console.log("test")
        }
      });
  }

  	setselectedtheme(sel) {	
		this.setState({ selTheme: { value: sel.value, label: sel.label }, theme_id : sel.value });
	}

  setselectedvalue(selectsers) {
    const fontArray = selectsers.map((fonttype, index) => ({
      id: index,
      name: fonttype,
    }));
    // Dynamically create select list
    let fonts = [];
    fontArray.map((item) =>
      fonts.push({ label: item.name.label, value: item.name.value })
    );
    this.setState({ selectedFont: fonts });
  }
  setselectedvariants(selectvarients = null) {
    // const fontVariantArray = selectvarients.map((fontvar, index) => ({
    //  id: index,
    //  name: fontvar,
    // }));
    // Dynamically create select list
    //let fonts = [];
    selectvarients = selectvarients != null ? selectvarients : {};
    if (Object.keys(selectvarients).length > 0) {
      var listings = selectvarients.map((item, index) => {
        //fonts.push({ variant_id: item.name.id, variant_name: item.name.varient_name }),
        //console.log(item.id, '--isChecked')
        if (item.isChecked == "checked") {
          this.state.st_varient_id.push(item.id);
        }
        //this.setState({ st_varient_id: [...this.state.st_varient_id, item.id] });
        return (
          <div className="form-group" key={index}>
            <input
              onChange={this.handleCheckBoxChange.bind(this)}
              type="checkbox"
              name="st_varients"
              value={item.id}
              defaultChecked={item.isChecked}
            />
            <span>{item.varient_name + " " + item.variant_weight}</span>
          </div>
        );
      });
    } else {
      var listings = "";
      this.setState({ st_varient_id: [] });
    }
    this.setState({ selectedFontVariant: listings });
  }

  handleCheckBoxChange = (e) => {
    const isChecked = e.target.checked;
    const isCheckedVal = e.target.value;

    if (isChecked) {
      this.setState({
        st_varient_id: [...this.state.st_varient_id, e.target.value],
      });
    } else {
      // setSelectedId(selectedIds.filter(id=>id !== checkedId))
      // const index = this.state.st_varient_id.indexOf(e.target.value);
      // this.state.st_varient_id.splice(index,1);
      this.setState({
        st_varient_id: this.state.st_varient_id.filter(
          (id) => id !== e.target.value
        ),
      });
    }
  };

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  /* handleChange = (color) => {
	this.setState({hexColor : color.hex})
	this.setState({ color: color.rgb })
	}; */

  copyCodeToClipboard(event) {
    event.preventDefault;
    const el = this.textArea;
    el.select();
    document.execCommand("copy");
  }

  writeText = () => {
    $(".copied_title").html('<span class=""><h3>Copied</h3></span>');

    //onClick={() =>  navigator.clipboard.writeText(tester)}
    //let test1 = this.state.settings_access_code;
    let test1 = this.state.settings_result_access_code[0].access_code;

    let tester =
      '<script src="https://admin.jubr.one/plugin.js"></script> <div data-client="' +
      test1 +
      '"  id="carbook_container"></div>';
    navigator.clipboard.writeText(tester);
    setTimeout(
      function () {
        $(".copied_title").html("");
        $(".copied_title").hide();
      }.bind(this),
      3000
    );
  };
  writeText2 = () => {
    $(".copied_title").html('<span class=""><h3>Copied</h3></span>');

    //onClick={() =>  navigator.clipboard.writeText(tester)}
    //let test1 = this.state.settings_access_code;
    let test1 = this.state.settings_result_access_code[1].access_code;

    let tester =
      '<script src="https://admin.jubr.one/plugin.js"></script> <div data-client="' +
      test1 +
      '"  id="busbook_container"></div>';
    navigator.clipboard.writeText(tester);
    setTimeout(
      function () {
        $(".copied_title").html("");
        $(".copied_title").hide();
      }.bind(this),
      3000
    );
  };

  copyShortEmbed = (embedCarStandalone) => {
    $(".shortCarEmbedTitle").html('<span class=""><h3>Copied</h3></span>');        
    navigator.clipboard.writeText(embedCarStandalone);
    setTimeout(
      function () {
        $(".shortCarEmbedTitle").html("");
        $(".shortCarEmbedTitle").hide();
      }.bind(this),
      3000
    );
  };
  copyBusShortEmbed = (embedBusStandalone) => {
    $(".shortBusEmbedTitle").html('<span class=""><h3>Copied</h3></span>');        
    navigator.clipboard.writeText(embedBusStandalone);
    setTimeout(
      function () {
        $(".shortBusEmbedTitle").html("");
        $(".shortBusEmbedTitle").hide();
      }.bind(this),
      3000
    );
  };

  /*    myCallback = (domainsets) => {
   	//console.log(domainsets,'domainsets')
    this.setState({domainSets: domainsets});
  }; */

  myCallback = (domainsets, domainID, domain_count) => {
    console.log(domainsets, "--domainsets");
    this.setState({
      domainSets: domainsets,
      cardomainSets: domainsets,
      removeID: domainID,
      domain_count: domain_count,
    });
  };
  myCallback2 = (domainsets, domainID, domain_count) => {
    console.log(domainsets, "--domainsets");
    this.setState({
      domainSets: domainsets,
      busdomainSets: domainsets,
      removeID: domainID,
      domain_count: domain_count,
    });
  };
  handleChangeFont = (selectedFont) => {
    this.setState({ selectedFont });
    this.setState({ fontvalue: selectedFont.value });
    if (selectedFont.value === "") {
      //$('.errorfont').html('<span class="errorspan">Please select the font</span>');
    } else {
      axios
        .get(
          apiUrl + "adminpanel/getfont_varient?font_id=" + selectedFont.value
        )
        .then((res) => {
          if (res.data.status == "success") {
            //if(res.data.fontvarientlist!== '' && res.data.fontvarientlist!== null){
            this.setselectedvariants(res.data.fontvarientlist);
            //}
          } else {
            //console.log("test")
            this.setselectedvariants(res.data.fontvarientlist);
          }
        });
      $(".errorfont").html("");
    }
  };

  handleChangeAimodeluser = (selectedfaqmodeluser) => {
    this.setState({ selectedfaqmodeluser });
    this.setState({ selectedfaqmodeluserval: selectedfaqmodeluser.value });
  };
  handleChangeAimodelguest = (selectedfaqmodelguest) => {
    this.setState({ selectedfaqmodelguest });
    this.setState({ selectedfaqmodelguestval: selectedfaqmodelguest.value });
  };

  handleChangeAimodelcompany = (selectedfaqmodelcompany) => {
    this.setState({ selectedfaqmodelcompany });
    this.setState({
      selectedfaqmodelcompanyval: selectedfaqmodelcompany.value,
    });
  };
  handleChangeAimodelrehab = (selectedfaqmodelrehab) => {
    this.setState({ selectedfaqmodelrehab });
    this.setState({ selectedfaqmodelrehabval: selectedfaqmodelrehab.value });
  };

  handleSave = () => {
    this.setState({ Loading: true });
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const formPayload = this.state;
    var qs = require("qs");
    var postObject = {
      settings_id: formPayload.settings_id,
      admin_id: localStorage.getItem("admin_id"),
      aifeed: this.state.description,
      type: formPayload.type,
      imp_cate: 6,
    };

    let formData = new FormData();
    for (let k in postObject) {
      formData.append(k, postObject[k]);
    }

    axios
      .post(apiUrl + "faq/settingaifeedsave", formData, config)
      .then((res) => {
        if (res.data.results) {
          // this.setState({Loading:false});
          // 		const formpayload = res.data.results;
          // 		$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
          // 		this.setState({settings_id:formpayload.settings_id});
          // 		scrollToTop();
          // 		setTimeout(
          // 			function() {
          // 				$('.success_message').html('');
          // 			}
          // 			.bind(this),
          // 			3000
          // 			);
        }
      });
  };

  // ================================font start ====================
  addFunc = (e) => {
    this.setState((prevState) => ({
      fontDetails: [
        ...prevState.fontDetails,
        {
          index: Math.random(),
          FontType: "",
          FontId: "",
          fontSize: "",
          fontWeight: "",
          letterSpacing: "",
          lineHeight: "",
          TopSpace: "",
          BottomSpace: "",
          varient_id: "",
        },
      ],
    }));
  };
  deleteFunc(record) {
    this.setState({
      fontDetails: this.state.fontDetails.filter((r) => r !== record),
    });
  }
  Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  addMoreFunc = (e) => {
    return this.state.fontDetails.map((val, idx) => {
      let FontType = `FontType${idx}`,
        fontWeight = `fontWeight${idx}`,
        FontSize = `FontSize${idx}`,
        letterSpacing = `letterSpacing${idx}`,
        lineHeight = `lineHeight${idx}`,
        TopSpace = `TopSpace${idx}`,
        BottomSpace = `BottomSpace${idx}`,
        errorfile = `errorfile${idx}`;
      return (
        <>
          <div className="form-row mb-0" key={val.index}>
            <div className="form-left">
              <div className="form-group">
                <label className="pb-0">
                  {/* Apply font : */}
                  Font Apply to {this.Capitalize(val.fontType)}
                </label>
                {/* <div className='d-flex align-items-center gap-3'>					
					<select name="FontType" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>
						<option value="" className="fontVarientName" > Select Type</option>
						<option value="PrimaryFont" className="fontVarientName" selected={val.FontType=='PrimaryFont'?true:false} > Primary Font</option>
						<option value="mainTab" className="fontVarientName" selected={val.FontType=='mainTab'?true:false} > MainTab</option>
						<option value="sideMenu" className="fontVarientName" selected={val.FontType=='sideMenu'?true:false} > SideMenu</option>
						<option value="title" className="fontVarientName" selected={val.FontType=='title'?true:false} > Title</option>
						<option value="subTitle" className="fontVarientName" selected={val.FontType=='subTitle'?true:false}> SubTitle</option>
						<option value="button" className="fontVarientName"selected={val.FontType=='button'?true:false} > Button</option>
						<option value="smButton" className="fontVarientName" selected={val.FontType=='smButton'?true:false}> SmallButton</option>
						<option value="lgButton" className="fontVarientName" selected={val.FontType=='lgButton'?true:false}> LargeButton</option>										
					</select>						
					{idx === 0 ? (
					<span className="add_font_varients cursor-pointer"  onClick={() => this.addFunc()}><i class="fa fa-plus-circle fa-1x"></i></span> ) : 
					<span className="btn_remove cursor-pointer" onClick={() => this.deleteFunc(val)} ><i class="fa fa-trash fa-1x"></i></span>
					}	
					</div>	 */}
                <div className="mt-2">{val.FontTypeCheck}</div>
              </div>
            </div>
          </div>
          <div className="form-row" key={val.index}>
            {this.varientField(
              val.fontId,
              val.fontFamily,
              val.fontType,
              idx,
              val,
              val.index
            )}
          </div>
        </>
      );
    });
  };

  regularOption = (val) => {
    return (
      <>
        <option
          value="200"
          className="fontVarientName"
          selected={val.fontWeight === "200"}
        >
          Extra Light 200
        </option>
        <option
          value="300"
          className="fontVarientName"
          selected={val.fontWeight === "300"}
        >
          Light 300
        </option>
        <option
          value="400"
          className="fontVarientName"
          selected={val.fontWeight === "400"}
        >
          Regular 400
        </option>
        <option
          value="500"
          className="fontVarientName"
          selected={val.fontWeight === "500"}
        >
          Medium 500
        </option>
        <option
          value="600"
          className="fontVarientName"
          selected={val.fontWeight === "600"}
        >
          Semi Bold 600
        </option>
        <option
          value="700"
          className="fontVarientName"
          selected={val.fontWeight === "700"}
        >
          Bold 700
        </option>
        <option
          value="800"
          className="fontVarientName"
          selected={val.fontWeight === "800"}
        >
          Extra Bold 800
        </option>
        <option
          value="900"
          className="fontVarientName"
          selected={val.fontWeight === "900"}
        >
          Black 900
        </option>
      </>
    );
  };

  handleFileChangeVarients = async (e, idx, fontLabel, fontValue) => {
    let font_file = `font_file${idx}`;
    let fontDetails = [...this.state.fontDetails];

    fontDetails[idx] = {
      ...fontDetails[idx],
      fontWeight: e.target.value,
    };
    fontDetails[e.target.dataset.id]["varient_id"] = idx;
    fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
    let selectedFont = e.target.name;
    this.setState({ fontDetails }, () => {
      console.log(this.state.fontDetails, "Updated fontDetails");
    });
  };

  varientField = (FontId, FontFamily, FontType, idx, val, selIndex) => {
    const fontArray = this.state.fonttype.map((fonttype, index) => ({
      id: index,
      name: fonttype,
    }));

    console.log(fontArray, "this is for font array");
    // Dynamically create select list
    let fonts = [];
    fontArray.map((item) =>
      fonts.push({
        label: item.name.label,
        value: item.name.value,
        fontStyles: item.name.tf_fontStyles,
        typeIs: item.name.tf_font_type,
        type: item.name.type,
      })
    );

    let fontWeight = `fontWeight${idx}`,
      FontSize = `FontSize${idx}`,
      FontIndId = `FontId${idx}`,
      letterSpacing = `letterSpacing${idx}`,
      lineHeight = `lineHeight${idx}`,
      TopSpace = `TopSpace${idx}`,
      BottomSpace = `BottomSpace${idx}`,
      LgButtonRadius = `LgButtonRadius${idx}`,
      errorfile = `errorfile${idx}`;
    //if(FontType !=='smallButton' && FontType!=='largeButton'){
    return (
      <>
        <div className="form-left">
          <div className="form-group">
            <label>Font Family :</label>
            <div>
              <select
                name="font_id"
                className="form-control"
                id={FontType}
                data-id={idx}
                value={val.font_id?.toString() || ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  const selectedOption = fonts.find(
                    (option) => option.value === selectedValue
                  );
                  this.handleFileChange(
                    e,
                    idx,
                    selectedOption?.label,
                    selectedOption?.value
                  );
                }}
              >
                <option value="">Select Font</option>

                <optgroup label="System Fonts">
                  {fonts
                    .filter((f) => f.type === "system_font")
                    .map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                </optgroup>
                <optgroup label="Google Fonts">
                  {fonts
                    .filter((f) => f.type === "google_font")
                    .map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                </optgroup>
                {console.log(fonts, "this is for fonts label")}
                <optgroup label="Custom Fonts">
                  {fonts
                    .filter((f) => f.type === "normal_font")
                    .map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                </optgroup>
              </select>
              <div className={errorfile}></div>
            </div>
          </div>
        </div>
        <div className="form-right">
          <div className="form-group">
            <label>Font Variant :</label>
            <div>
              <select
                name="fontWeight"
                className="form-control"
                id={FontType}
                data-id={idx}
                onChange={(e) => this.handleFileChangeVarients(e, idx)}
              >
                <option value="" className="fontVarientName">
                  Select Variant
                </option>
                {console.log(this.state.fontDetails, "this is fontsdetails")}
                {this.state.fontDetails[idx]?.variants?.map((variant) => (
                  <option
                    key={variant.value}
                    value={variant.value || val.fontWeight}
                    selected={val.fontWeight == variant.value ? true : false}
                  >
                    {variant.label} {variant.value}
                  </option>
                ))}
              </select>

              <div className={errorfile}></div>
            </div>
          </div>
        </div>

        <div className="form-left">
          <div className="form-group">
            <label>Font Size :</label>
            <div>
              <input
                type="text"
                name="fontSize"
                onChange={(e) => this.handleFileChange(e, idx)}
                //onChange={this.onFileChange}
                value={val.fontSize}
                data-id={idx}
                id={FontSize}
              />

              <div className={errorfile}></div>
            </div>
          </div>
        </div>
        <div className="form-right">
          <div className="form-group">
            <label>Letter Spacing :</label>
            <div>
              <input
                type="text"
                name="letterSpacing"
                onChange={(e) => this.handleFileChange(e, idx)}
                //onChange={this.onFileChange}
                value={val.letterSpacing}
                data-id={idx}
                id={letterSpacing}
              />

              <div className={errorfile}></div>
            </div>
          </div>
        </div>
        {console.log(FontType, "thi is fonttype")}
        {FontType == "smallButton" ||
        FontType == "largeButton" ||
        FontType == "pluginOpenButton" ? (
          <>
            <div className="form-left">
              <div className="form-group">
                <label>Top Space :</label>
                <div>
                  <input
                    type="text"
                    name="topSpace"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.topSpace}
                    data-id={idx}
                    id={TopSpace}
                  />

                  <div className={errorfile}></div>
                </div>
              </div>
            </div>
            <div className="form-right">
              <div className="form-group">
                <label>Bottom Space :</label>
                <div>
                  <input
                    type="text"
                    name="bottomSpace"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.bottomSpace}
                    data-id={idx}
                    id={BottomSpace}
                  />
                  <div className={errorfile}></div>
                </div>
              </div>
            </div>
            <div className="form-left">
              <div className="form-group">
                <label>Radius :</label>
                <div>
                  <input
                    type="text"
                    name="lgButtonRadius"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.lgButtonRadius}
                    data-id={idx}
                    id={LgButtonRadius}
                  />

                  <div className={errorfile}></div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </>
    );
  };
  varientFieldpld = (FontId, FontFamily, FontType, idx, val, selIndex) => {
    console.log(FontType);

    console.log("done");
    const fontArray = this.state.fonttype.map((fonttype, index) => ({
      id: index,
      name: fonttype,
    }));
    // Dynamically create select list
    let fonts = [];
    fontArray.map((item) =>
      fonts.push({
        label: item.name.label,
        value: item.name.value,
        fontStyles: item.name.tf_fontStyles,
        typeIs: item.name.tf_font_type,
      })
    );

    console.log(fontArray);

    let fontWeight = `fontWeight${idx}`,
      FontSize = `FontSize${idx}`,
      FontIndId = `FontId${idx}`,
      letterSpacing = `letterSpacing${idx}`,
      lineHeight = `lineHeight${idx}`,
      TopSpace = `TopSpace${idx}`,
      LgButtonRadius = `lgButtonRadius${idx}`,
      BottomSpace = `BottomSpace${idx}`,
      errorfile = `errorfile${idx}`;
    //if(FontType !=='smallButton' && FontType!=='largeButton'){
    return (
      <>
        <div className="form-left">
          <div className="form-group">
            <label>Font Family :</label>
            <div>
              {/* <Select 
							options={fonts}  
							value={FontFamily}
							//onChange={this.handleChangeFont}
							placeholder="Select Font Type" 
							name="FontFamily" 
							id={FontIndId} 
							data-id={idx} 								
							onChange={(e) => this.handleFileChange(e, idx)}
						/> */}

              <select
                name="font_id"
                className="form-control"
                id={FontType}
                data-id={idx}
                onChange={(e) => this.handleFileChange(e, idx, selIndex)}
              >
                <option value="" className="fontFamilyId">
                  {" "}
                  Select Font
                </option>
                {fonts.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    selected={val.font_id == option.value ? true : false}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
              <div className={errorfile}></div>
            </div>
          </div>
        </div>
        <div className="form-right">
          <div className="form-group">
            <label>Font Variant :</label>
            <div>
              <select
                name="fontWeight"
                className="form-control"
                id={FontType}
                data-id={idx}
                onChange={(e) => this.handleFileChange(e, idx)}
              >
                <option value="" className="fontVarientName">
                  {" "}
                  Select Variant
                </option>
                <option
                  value="200"
                  className="fontVarientName"
                  selected={val.fontWeight == "200" ? true : false}
                >
                  {" "}
                  Extra Light200
                </option>
                <option
                  value="300"
                  className="fontVarientName"
                  selected={val.fontWeight == "300" ? true : false}
                >
                  {" "}
                  Light 300
                </option>
                <option
                  value="400"
                  className="fontVarientName"
                  selected={val.fontWeight == "400" ? true : false}
                >
                  {" "}
                  Regular 400
                </option>
                <option
                  value="500"
                  className="fontVarientName"
                  selected={val.fontWeight == "500" ? true : false}
                >
                  {" "}
                  Medium 500
                </option>
                <option
                  value="600"
                  className="fontVarientName"
                  selected={val.fontWeight == "600" ? true : false}
                >
                  {" "}
                  Semi Bold 600
                </option>
                <option
                  value="700"
                  className="fontVarientName"
                  selected={val.fontWeight == "700" ? true : false}
                >
                  {" "}
                  Bold 700
                </option>
                <option
                  value="800"
                  className="fontVarientName"
                  selected={val.fontWeight == "800" ? true : false}
                >
                  {" "}
                  Extra Bold 800
                </option>
                <option
                  value="900"
                  className="fontVarientName"
                  selected={val.fontWeight == "900" ? true : false}
                >
                  Black 900
                </option>
              </select>

              <div className={errorfile}></div>
            </div>
          </div>
        </div>
        <div className="form-left">
          <div className="form-group">
            <label>Font Size :</label>
            <div>
              <input
                type="text"
                name="fontSize"
                onChange={(e) => this.handleFileChange(e, idx)}
                //onChange={this.onFileChange}
                value={val.fontSize}
                data-id={idx}
                id={FontSize}
              />

              <div className={errorfile}></div>
            </div>
          </div>
        </div>
        <div className="form-right">
          <div className="form-group">
            <label>Letter Spacing :</label>
            <div>
              <input
                type="text"
                name="letterSpacing"
                onChange={(e) => this.handleFileChange(e, idx)}
                //onChange={this.onFileChange}
                value={val.letterSpacing}
                data-id={idx}
                id={letterSpacing}
              />

              <div className={errorfile}></div>
            </div>
          </div>
        </div>
        {FontType == "smallButton" ||
        FontType == "largeButton" ||
        FontType == "pluginOpenButton" ? (
          <>
            <div className="form-left">
              <div className="form-group">
                <label>Top Space :</label>
                <div>
                  <input
                    type="text"
                    name="topSpace"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.topSpace}
                    data-id={idx}
                    id={TopSpace}
                  />

                  <div className={errorfile}></div>
                </div>
              </div>
            </div>
            <div className="form-right">
              <div className="form-group">
                <label>Bottom Space :</label>
                <div>
                  <input
                    type="text"
                    name="bottomSpace"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.bottomSpace}
                    data-id={idx}
                    id={BottomSpace}
                  />
                  <div className={errorfile}></div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </>
    );
    //}
    // if(FontType =='smallButton' || FontType=='largeButton'){
    // 	return(<>
    // 	<div className="form-left">
    // 		<div className="form-group">
    // 			<label>Top Space :</label>
    // 			<div>
    // 				<input type="text" name="TopSpace"
    // 				onChange={(e) => this.handleFileChange(e, idx)}
    // 				value={val.topSpace}
    // 				data-id={idx}
    // 				id={TopSpace}    />

    // 				<div className={errorfile}></div>
    // 			</div>
    // 		</div>
    // 	</div>
    // 	<div className="form-right">
    // 		<div className="form-group">
    // 			<label>Bottom Space :</label>
    // 			<div>
    // 				<input type="text" name="BottomSpace"
    // 				onChange={(e) => this.handleFileChange(e, idx)}
    // 				value={val.bottomSpace}
    // 				data-id={idx}
    // 				id={BottomSpace}    />
    // 				<div className={errorfile}></div>
    // 			</div>
    // 		</div>
    // 	</div>
    // 	</>);
    // }
  };
  handleFileChange = async (e, idx, fontLabel, fontValue) => {
    let font_file = `font_file${idx}`;
    let fontDetails = [...this.state.fontDetails];
    fontDetails[e.target.dataset.id]["varient_id"] = idx;
    fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
    let selectedFont = e.target.name;
    if (fontValue) {
      try {
        const response = await axios.get(`${apiUrl}font/getvarientlistdetail`, {
          params: {
            id: fontValue,
            name: fontLabel,
          },
        });
        if (response.data.variants) {
          fontDetails[idx] = {
            ...fontDetails[idx],
            variants: response.data.variants,
          };
          console.log(response.data.variants, "this is fortvarientrecords");
        }
      } catch (error) {
        console.error("Error fetching font variants:", error);
      }
    }

    this.setState({ fontDetails }, () => {
      console.log(this.state.fontDetails, "Updated fontDetails");
    });
  };
  handleFileChangeold = (e, idx) => {
    console.log(e, "--handleFileChange");
    let font_file = `font_file${idx}`;
    let fontDetails = [...this.state.fontDetails];
    const updatedfontidSave = [...this.state.fontidSave, idx];
    console.log(fontDetails, "--handleFileChange2");
    fontDetails[e.target.dataset.id]["varient_id"] = idx;
    fontDetails[e.target.dataset.id][e.target.name] = e.target.value;

    this.setState({
      fontDetails: fontDetails,
      fontidSave: updatedfontidSave,
    });
  };
  handleCancel = () => {
    const popup = document.querySelector(".input-popup-action");
    if (popup) {
      popup.classList.remove("show");
    }
  };
  handleSubmit = () => {
    // this.setState({ inputValue: this.state.shadow });
    // if (this.inputRef.current) {
    //   this.inputRef.current.value = this.state.shadow;
    // }
    // remove 'show' class from input-popup-action
    const popup = document.querySelector(".input-popup-action");
    if (popup) {
      popup.classList.remove("show");
    }
  };
  // ================================font end ====================
  confirmPopupold = () => {
    $(".input-popup-action").addClass("show");
  };
  confirmPopup = (type) => {
    this.setState({ activeShadowType: type });
    $(".input-popup-action").addClass("show");
  };
  handleShadowChange = (value) => {
    this.setState((prevState) => ({
      shadows: {
        ...prevState.shadows,
        [this.state.activeShadowType]: value,
      },
    }));
  };

  labelFor = (key) => {
    const labels = {
      pluginShadow: "Plugin Shadow",
	  pluginInsideLeftShadow: "Plugin Inside Left Shadow",
	   pluginInsideRightShadow: "Plugin Inside Right Shadow",
	   pluginInsideTopShadow: "Plugin Inside Top Shadow",
	   pluginInsideBottomShadow: "Plugin Inside Bottom Shadow",
    //   pluginInset: "Plugin Inside Shadow",
      dashboardShadowGrid: "Dashboard Grid Shadow",
      dashboardShadowList: "Dashboard List Shadow",

      shortcutMenu: "Shortcut Menu Shadow (Shotcut menu, AI screen textarea)",
      largeButton: "Button Shadow (Large, Small)",

      // smallButton: "Small Button Shadow",
      // sidePopup: "Side Popup Shadow",
      textarea: "Textarea Shadow",
      dropdownmenu:
        "Dropdown Menu Shadow (Bell notification, Group menu in listing screen, Address dropdown)",
      shadowAISidebar: "AI Sidebar Shadow",
      shadowListRow: "List Shadow",
      shadowTableRow: "Table Shadow",
      shadowLeftSidebar: "Left Sidebar Shadow (Side Menu)",
      shadowRightSidebar:
        "Right Sidebar Shadow (Chat window, Guest Payment Form)",
      shadowMapPopup: "Map Popup Shadow (View Map) ",
      shadowSearchDropdown:
        "Search Dropdown Shadow (Pickup and Where location dropdown) ",
    };

    return labels[key] || key;
  };
  handleInputChangeShadows = (type, value) => {
    this.setState((prevState) => ({
      shadows: {
        ...prevState.shadows,
        [type]: value,
      },
    }));
  };
  handleLandingPageChange = (selectedOption) => {
    this.setState({ landing_page: selectedOption.value });
  };

  handlePositionChange = (selectedOption) => {
    this.setState({ st_position: selectedOption.value }, () => {
      if (selectedOption.value == "absolute") {
        $(".d-height").removeClass("d-none");
      } else {
        $(".d-height").addClass("d-none");
      }
    });
  };

  handleChangeTheme = sel => {
		this.setState({ selTheme : sel});
		this.setState({ theme_id : sel.value });
	}
  handleOnDropChange = (r,selOption) => {       
		if(r == 'bookingTiming'){
			this.setState({ bookingTimingSel:selOption, bookingTimingVal : selOption.value});
		}
    else if(r == 'internationalFlightTiming'){			
			this.setState({ internationalFlightTimingSel:selOption, internationalFlightTimingVal : selOption.value});
		}
    else if(r == 'domesticFlightTiming'){			
			this.setState({ domesticTimingSel:selOption, domesticTimingVal : selOption.value});
		}
    else if(r == 'cancellationChargeType'){			
			this.setState({ cancellationChargeTypeSel:selOption, cancellationChargeType : selOption.value});
		}
    else if(r == 'editRideTimeLimit'){			
			this.setState({ editRideTimeLimitSel:selOption, editRideTimeLimitVal : selOption.value});
		}
  };

  render() {
    const { shadows, activeShadowType, selTheme, bookingTimingSel, bookingTimingVal, internationalFlightTimingSel, internationalFlightTimingVal, domesticTimingSel, domesticTimingVal, editRideTimeLimitSel } = this.state;
    // var scalar_icon_preview = (this.state.scalar_icon_preview) ? 
		// <img src={this.state.scalar_icon_preview} alt="" width="120"/> :
		// <img src={mediaUrl+'settings/'+this.state.old_scalar_icon_img} alt="" width="120"/>;
    /* const styles = reactCSS({
      'default': {
        color: {
          width: '36px',
          height: '14px',
          borderRadius: '2px',
          background: `${ this.state.hexColor }`,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    }); */
    var test1 = this.state.settings_access_code;
    var test2 = this.state.settings_access_code;
    //setTimeout(function () {
    if (
      this.state.settings_result_access_code &&
      this.state.settings_result_access_code.length > 1
    ) {
      test1 = this.state.settings_result_access_code[0]?.access_code || "";
      test2 = this.state.settings_result_access_code[1]?.access_code || "";
    }
    //},3000);

    //let test1 = this.state.settings_access_code;
    // let test1 = this.state.settings_result_access_code[0].access_code;
    // let test2 = this.state.settings_result_access_code[1].access_code;
    //let test = Number(this.state.settings_access_code);

    const scripttype = "";

    /*const tester =	'<!-- Include <div> tag after the script -->\n<script src="http://car-c.uxt.design/plugin.js"></script>\n<div data-client="'+test+'"  id="car_container"></div>';
     */

    // let  tester =	'<script src="https://admin.we.rehab/plugin.js"></script> <div data-client="'+test1+'"  id="rehab_container"></div>';
    let tester =
      '<script src="https://admin.jubr.one/plugin.js"></script> <div data-client="' +
      test1 +
      '"  id="carbook_container"></div>';
    let tester2 =
      '<script src="https://admin.jubr.one/plugin.js"></script> <div data-client="' +
      test2 +
      '"  id="busbook_container"></div>';

    let embedCarStandalone =
      '<script src="https://admin.jubr.one/plugin.js"></script> <div data-client="' +
      test1 +
      '"  id="carbook_container" class="carbook_standalone"></div>';
    let embedBusStandalone =
      '<script src="https://admin.jubr.one/plugin.js"></script> <div data-client="' +
      test2 +
      '"  id="busbook_container" class="busbook_standalone"></div>';

    const fontArray = this.state.fonttype.map((fonttype, index) => ({
      id: index,
      name: fonttype,
    }));
    // Dynamically create select list
    let fonts = [];
    fontArray.map((item) =>
      fonts.push({ label: item.name.label, value: item.name.value })
    );

    const {
      selectedFont,
      selectedfaqmodeluser,
      selectedfaqmodelguest,
      selectedfaqmodelrehab,
      selectedfaqmodelcompany,
      fontDetails,
      selPluginSize,
      selPluginSizeVal,
      pluginSizeDetails,
    } = this.state;

    const style_text = {
      color: "white",
      backgroundColor: "#000",
      padding: "9px 9px",
      minwidth: "49px",
      height: "37px",
      textalign: "center",
      texttransform: "capitalize",
    };
    console.log(fontDetails, "--fontDetails");
    if (this.state.cancellation_fees_type == "flat") {
      $(".cancellation_fee").html("Cancellation fees ($):");
    } else {
      $(".cancellation_fee").html("Cancellation fees (%):");
    }
    if (this.state.reschedule_fees_type == "flat") {
      $(".reschedule_fee").html("Reschedule fees ($):");
    } else {
      $(".reschedule_fee").html("Reschedule fees (%):");
    }
    var refresh_token = this.state.dr_refresh_token;
    var yourclientid = this.state.drchrono_client_id;
    if (
      this.state.drchrono_client_id == "" &&
      this.state.drchrono_client_secret_key == ""
    ) {
      refresh_token = "";
    }

    if (this.state.drchrono_client_id == "") {
      yourclientid = "YOUR_CLIENT_ID";
    }
    console.log(this.state.domain_count, "domain_countdomain_count");
    return (
      <div className="wrapper">
        <Header />
        <MenuSidebar currentpage="setting" currentTab="common" />

        <div className="content">
          <div className="content-wrapper">
            <div class="content-wrapper-before"></div>
            <div className="content-body setting-main-head leaa-admin-head card">
              <form
                className="settings"
                onSubmit={(e) => {
                  this.handleFormSubmit(this);
                  e.preventDefault();
                }}
              >
                <div className="form-wrapper">
                  <div className="success_message"></div>
                  <div className="title">
                    <h4>Settings</h4>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        {localStorage.getItem("admin_id") == 1 ? (
                          <label>
                            Site Name
                            <span class="required" style={{ color: "red" }}>
                              *{" "}
                            </span>
                          </label>
                        ) : (
                          <label>
                            Company Name
                            <span class="required" style={{ color: "red" }}>
                              *{" "}
                            </span>
                          </label>
                        )}

                        <input
                          type="text"
                          name="settings_site_title"
                          onChange={this.handleInputChange}
                          className="form-control"
                          value={this.state.settings_site_title}
                        />
                        <div className="errorsettings_site_title"></div>
                      </div>
                      <div className="form-group">
                        <label>
                          From Name
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <input
                          type="text"
                          name="settings_from_name"
                          onChange={this.handleInputChange}
                          className="form-control"
                          value={this.state.settings_from_name}
                        />
                        <div className="errorsettings_from_name"></div>
                      </div>
                      <div className="form-group">
                        <label>
                          From Email
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <input
                          type="text"
                          name="settings_from_email"
                          onChange={this.handleInputChange}
                          className="form-control"
                          value={this.state.settings_from_email}
                        />
                        <div className="errorsettings_from_email"></div>
                      </div>

                      {/* <div className="default-font">
			  <div className="form-group">
			  <label>Font<span class="required" style={{ color: "red" }} >* </span></label>
				     <Select 
                         options={fonts}  
                         value={selectedFont?selectedFont:{ value: '0', label: 'Select Font Type' }}
                         onChange={this.handleChangeFont}
                         placeholder="Select Font Type" />
					<div className="errorfont"></div>
				</div>
				</div>  */}
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        {localStorage.getItem("admin_id") == 1 ? (
                          <label>
                            Admin Email
                            <span class="required" style={{ color: "red" }}>
                              *{" "}
                            </span>
                          </label>
                        ) : (
                          <label>Company Email:</label>
                        )}
                        <input
                          type="text"
                          className="form-control"
                          onChange={this.handleInputChange}
                          name="settings_admin_email"
                          value={this.state.settings_admin_email}
                        />
                        <div className="errorsettings_admin_email"></div>
                      </div>

                      <div className="form-group">
                        <label>
                          Contact
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="settings_mobileno"
                          onChange={this.handleInputChange}
                          value={this.state.settings_mobileno}
                        />
                        <div className="errorsettings_mobileno"></div>
                      </div>

                      <div className="form-group">
                        <label>
                          Email Footer Content
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="settings_email_footer"
                          onChange={this.handleInputChange}
                          value={this.state.settings_email_footer}
                        />
                        <div className="errorsettings_email_footer"></div>
                      </div>

                      {/* <div className="form-group">
					<label>Payment Form:</label><br></br>
					    <input onChange={this.handleInputChange} type="radio" name="payment_form" checked={this.state.payment_form=='normal'?'chekced':''} value="normal"/>
	                <span>Normal</span>
	                 <input onChange={this.handleInputChange} type="radio"  name="payment_form" checked={this.state.payment_form=='widget'?'chekced':''} value="widget"/>
	                <span>Widget</span>
            	</div>  */}

                      {/* { localStorage.getItem('admin_id') == 1 ? <div className="form-group site-bg-clr"> 
				<label>Site Background Color: </label>
						<div style={ styles.swatch } onClick={ this.handleClick }>
						<div style={ styles.color } />
						</div>
						{ this.state.displayColorPicker ? <div style={ styles.popover }>
						<div style={ styles.cover } onClick={ this.handleClose }/>
						<SketchPicker color={ this.state.color } onChange={ this.handleChange } />
						</div> : null }
				</div> : '' } */}
                    </div>
                  </div>
                  <div className="title">
                    <h4>Mail Configuration Settings</h4>
                  </div>

                  <div className="form-group">
                    <input
                      onChange={this.handleInputChange}
                      type="checkbox"
                      name="settings_mail_from_smtp"
                      checked={this.state.smtp_checked}
                    />
                    <span>Send Mail From Smtp</span>
                  </div>

                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Smtp Host:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="settings_smtp_host"
                          onChange={this.handleInputChange}
                          value={
                            this.state.settings_smtp_host != "null"
                              ? this.state.settings_smtp_host
                              : ""
                          }
                        />
                        <div className="errorsettings_smtp_host"></div>
                      </div>
                      <div className="form-group">
                        <label>Smtp Username:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="settings_smtp_user"
                          onChange={this.handleInputChange}
                          value={
                            this.state.settings_smtp_user != "null"
                              ? this.state.settings_smtp_user
                              : ""
                          }
                        />
                        <div className="errorsettings_smtp_user"></div>
                      </div>
                      <div className="form-group">
                        <label>Smtp Password:</label>
                        <input
                          type="password"
                          className="form-control"
                          name="settings_smtp_pass"
                          onChange={this.handleInputChange}
                          value={
                            this.state.settings_smtp_pass != "null"
                              ? this.state.settings_smtp_pass
                              : ""
                          }
                        />
                        <div className="errorsettings_smtp_pass"></div>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <label>Smtp Port:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="settings_smtp_port"
                          onChange={this.handleInputChange}
                          value={
                            this.state.settings_smtp_port != "null"
                              ? this.state.settings_smtp_port
                              : ""
                          }
                        />
                        <div className="errorsettings_smtp_port"></div>
                      </div>
                      <div className="form-group">
                        <label>Mail Path:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="settings_mailpath"
                          onChange={this.handleInputChange}
                          placeholder=""
                          value={
                            this.state.settings_mailpath != "null"
                              ? this.state.settings_mailpath
                              : ""
                          }
                        />
                      </div>
                    </div>
                  </div>

                  {/* -------------chat ai setting start-------------- */}

                  <div className="title">
                    <h4>Chat AI Settings</h4>
                  </div>

                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Chat AI type: </label>
                      </div>
                      <div className="form-group">
                        <label>Chat AI key: </label>
                      </div>
                      <div className="form-group">
                        <label>Common / Guest Conversation</label>
                      </div>

                      {/* <div className="form-group">
                        <label>User Conversation</label>
                      </div>                     
                      <div className="form-group">
                        <label>Company Conversation</label>
                      </div> */}
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="aichat_type"
                          checked={
                            this.state.aichat_type == "text" ? "chekced" : ""
                          }
                          value="text"
                        />
                        <span>Text</span>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="aichat_type"
                          checked={
                            this.state.aichat_type == "chat" ? "chekced" : ""
                          }
                          value="chat"
                        />
                        <span>Chat </span>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="aichat_key"
                          onChange={this.handleInputChange}
                          value={
                            this.state.aichat_key != "null"
                              ? this.state.aichat_key
                              : ""
                          }
                        />
                      </div>
                      <div className="form-group">
                        <Select
                          options={this.state.faqmodelguest}
                          value={
                            selectedfaqmodelguest
                              ? selectedfaqmodelguest
                              : { value: "0", label: "Select guest ai model" }
                          }
                          onChange={this.handleChangeAimodelguest}
                          placeholder="Select AI Model ID"
                        />
                      </div>

                      {/* <div className="form-group">
                        <Select
                          options={this.state.faqmodeluser}
                          value={
                            selectedfaqmodeluser
                              ? selectedfaqmodeluser
                              : { value: "0", label: "Select user ai model" }
                          }
                          onChange={this.handleChangeAimodeluser}
                          placeholder="Select AI Model ID"
                        />
                      </div>
                     
                      <div className="form-group">
                        <Select
                          options={this.state.faqmodelcompany}
                          value={
                            selectedfaqmodelcompany
                              ? selectedfaqmodelcompany
                              : { value: "0", label: "Select company ai model" }
                          }
                          onChange={this.handleChangeAimodelcompany}
                          placeholder="Select AI Model ID"
                        />
                      </div> */}
                    </div>
                  </div>
                  {/* -------------chat ai setting end-------------- */}

                  {/* <div className="title">
                    <h4>Feed domain data</h4>
                  </div>

                  <div className="form-group">
                    <label>Type</label>
                    <input
                      type="radio"
                      name="type"
                      value="text"
                      onChange={this.handleInputChange}
                    />{" "}
                    AI Texting
                    <input
                      type="radio"
                      name="type"
                      value="chat"
                      onChange={this.handleInputChange}
                    />{" "}
                    Assistant Chat
                  </div>

                  <div className="form-group">                    
                    <CKEditor
                      editor={ClassicEditor}
                      data={this.state.description || ''}
                      onReady={(editor) => {
                        // You can store the "editor" and use when it is needed.
                        console.log("Editor is ready to use!", editor);
                      }}
                      name="aifeed_desc"
                      // onChange={this.handleInputChange}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        this.setState({ description: data });
                      }}
                    />
                    <div className="errordescription"></div>
                    <button
                      className="ai-feedbtn mt-3"
                      onClick={this.handleSave}
                    >
                      AI Feed
                    </button>
                  </div> */}

                  <div className="title">
                    <h4>Car Domain & Embed Code</h4>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Embed Code
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <p
                          className="right-side-header"
                          id="embed_code"
                          name="settings_embedcode"
                          value={tester}
                          title="Copy Text"
                        >
                          {tester}
                        </p>
                        <br></br>
                        <a
                          id="copytext"
                          style={style_text}
                          onClick={this.writeText}
                        >
                          Copy{" "}
                        </a>{" "}
                        <br></br>
                        <div>
                          <br></br>
                          <div className="copied_title"></div>
                        </div>
                        <div className="errorsettings_embedcode_title"></div>
                      </div>

                      <div className="form-group">
                        <label>
                          Short Form Embed Code
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <p
                          className="right-side-header"
                          id="embedCarStandalone"
                          name="embedCarStandalone"
                          value={embedCarStandalone}
                          title="Copy Text"
                        >
                          {embedCarStandalone}
                        </p>
                        <br></br>
                        <a
                          id="copytext"
                          style={style_text}
                          onClick={this.copyShortEmbed.bind(this, embedCarStandalone)}
                        >
                          Copy{" "}
                        </a>{" "}
                        <br></br>
                        <div>
                          <br></br>
                          <div className="shortCarEmbedTitle"></div>
                        </div>
                        <div className="errorshortCarEmbedTitle"></div>
                      </div>

                      <div className="form-group">
                        <h4>Google Analytics code </h4>
                        <textarea
                          type="text"
                          name="google_analystic_code"
                          onChange={this.handleInputChange}
                          className="form-control"
                          value={this.state.google_analystic_code}
                        />
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <h4>
                          Domain
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </h4>
                        <div className="domain-url">
                          <Addinputsimple
                            myCallback={this.myCallback}
                            domainname={this.state.cardomainSets}
                            domain_count={this.state.domain_count}
                          />
                        </div>
                        <div className="errorsettings_domain"></div>
                      </div>
                    </div>
                  </div>

                  <div className="title">
                    <h4>Bus Domain & Embed Code</h4>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Embed Code
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <p
                          className="right-side-header"
                          id="embed_code"
                          name="settings_embedcode"
                          value={tester2}
                          title="Copy Text"
                        >
                          {tester2}
                        </p>
                        <br></br>
                        <a
                          id="shortcarembedcopytext"
                          style={style_text}
                          onClick={this.writeText2}
                        >
                          Copy{" "}
                        </a>{" "}
                        <br></br>
                        <div>
                          <br></br>
                          <div className="copied_title"></div>
                        </div>
                        <div className="errorsettings_embedcode_title"></div>
                      </div>

                      <div className="form-group">
                        <label>
                          Short Form Embed Code
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <p
                          className="right-side-header"
                          id="embedBusStandalone"
                          name="embedBusStandalone"
                          value={embedBusStandalone}
                          title="Copy Text"
                        >
                          {embedBusStandalone}
                        </p>
                        <br></br>
                        <a
                          id="shortbusembedcopytext"
                          style={style_text}
                          onClick={this.copyBusShortEmbed.bind(this, embedBusStandalone)}
                        >
                          Copy{" "}
                        </a>{" "}
                        <br></br>
                        <div>
                          <br></br>
                          <div className="shortBusEmbedTitle"></div>
                        </div>
                        <div className="errorshortBusEmbedTitle"></div>
                      </div>

                      <div className="form-group">
                        <h4>Google Analytics code </h4>
                        <textarea
                          type="text"
                          name="google_analystic_code"
                          onChange={this.handleInputChange}
                          className="form-control"
                          value={this.state.google_analystic_code}
                        />
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <h4>
                          Domain
                          {/* <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span> */}
                        </h4>
                        <div className="domain-url">
                          <Addinputsimplebus
                            myCallback={this.myCallback2}
                            domainname={this.state.busdomainSets}
                            domain_count={this.state.domain_count}
                          />
                        </div>
                        <div className="errorsettings_busdomain"></div>
                      </div>
                    </div>
                  </div>

                  <div className="title">
                    <h4>Plugin Management</h4>
                  </div>

                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Plugin Position</label>
                        <br />
                        <Select
                          name="st_position"
                          value={lang.common.pluginPosition.find(
                            (option) => option.value === this.state.st_position
                          )}
                          options={lang.common.pluginPosition}
                          onChange={this.handlePositionChange}
                        />
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group d-height d-none">
                        <label>Plugin Height</label>
                        <input
                          type="text"
                          className="form-control"
                          name="st_plugin_height"
                          onChange={this.handleInputChange}
                          value={this.state.st_plugin_height}
                        />
                        <div className="errorst_st_plugin_height"></div>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Top (%) :</label>
                        <input
                          type="number"
                          className="form-control"
                          name="st_position_top"
                          onChange={this.handleInputChange}
                          value={this.state.st_position_top == 0 ? "10" : this.state.st_position_top}
                        />
                        <div className="errorsettings_st_position_top"></div>
                      </div>
                      <div className="form-group">
                        <label>Bottom (%) :</label>
                        <input
                          type="number"
                          className="form-control"
                          name="st_position_bottom"
                          onChange={this.handleInputChange}
                          value={this.state.st_position_bottom == 0 ? "10" : this.state.st_position_bottom}
                        />
                        <div className="errorsettings_st_position_bottom"></div>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group ">
                        <label>Left (%) :</label>
                        <input
                          type="number"
                          className="form-control"
                          name="st_position_left"
                          onChange={this.handleInputChange}
                          value={this.state.st_position_left == 0 ? "10" : this.state.st_position_left}
                        />
                        <div className="errorsettings_st_position_left"></div>
                      </div>
                      <div className="form-group">
                        <label>Right (%) :</label>
                        <input
                          type="number"
                          className="form-control"
                          name="st_position_right"
                          onChange={this.handleInputChange}
                          value={this.state.st_position_right == 0 ? "" : this.state.st_position_right}
                        />
                        <div className="errorsettings_st_position_right"></div>
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <h5>Plugin Inner Space:</h5>
                  </div>

                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Top (px) :</label>
                        <input
                          type="number"
                          className="form-control"
                          name="st_plugin_top_space"
                          onChange={this.handleInputChange}
                          value={this.state.st_plugin_top_space}
                        />
                        <div className="errorsettings_st_plugin_top_space"></div>
                      </div>
                      <div className="form-group">
                        <label>Bottom (px) :</label>
                        <input
                          type="number"
                          className="form-control"
                          name="st_plugin_bottom_space"
                          onChange={this.handleInputChange}
                          value={this.state.st_plugin_bottom_space}
                        />
                        <div className="errorsettings_st_plugin_bottom_space"></div>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group ">
                        <label>Left (px) :</label>
                        <input
                          type="number"
                          className="form-control"
                          name="st_plugin_left_space"
                          onChange={this.handleInputChange}
                          value={this.state.st_plugin_left_space}
                        />
                        <div className="errorsettings_st_plugin_left_space"></div>
                      </div>
                      <div className="form-group">
                        <label>Right (px) :</label>
                        <input
                          type="number"
                          className="form-control"
                          name="st_plugin_right_space"
                          onChange={this.handleInputChange}
                          value={this.state.st_plugin_right_space}
                        />
                        <div className="errorsettings_st_plugin_right_space"></div>
                      </div>
                    </div>
                  </div>
                   <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Short Form Plugin Width (px) :</label>
                        <input
                          type="number"
                          className="form-control"
                          name="st_short_form_plugin_width"
                          onChange={this.handleInputChange}
                          value={this.state.st_short_form_plugin_width}
                        />
                        <div className="errorsettings_st__short_form_plugin_width"></div>
                      </div>
                    </div>
                    </div>

                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Show category icons: </label>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="category_icons"
                          checked={this.state.category_icons_yes}
                        />
                        <span>Yes</span>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="category_icons"
                          checked={this.state.category_icons_no}
                        />
                        <span>No</span>
                      </div>
                      <div className="form-group">
                        <label>Dashboard View: </label>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="dashboard_view"
                          value="list"
                          checked={
                            this.state.dashboard_view == "list" ? "checked" : ""
                          }
                        />
                        <span>List</span>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="dashboard_view"
                          value="grid"
                          checked={
                            this.state.dashboard_view == "grid" ? "checked" : ""
                          }
                        />
                        <span>Grid</span>
                      </div>
                      {/* <div className="form-group">
						<label>Display Tab: </label>
					    <input onChange={this.handleInputChange} type="radio" name="display_tab" value="adsTab" checked={(this.state.display_tab == "adsTab" ? "checked" : "" )}/>
		                <span>Advertisement</span>
		                 <input onChange={this.handleInputChange} type="radio"  name="display_tab" value="mainTab" checked={(this.state.display_tab == "mainTab" ? "checked" : "" )}/>
		                <span>Main Tab</span>
 					</div> */}

           <div className="form-group">
                        <label>Plugin For: </label>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="st_plugin_for"
                          value="Car"
                          checked={
                            this.state.st_plugin_for == "Car" ? "checked" : ""
                          }
                        />
                        <span>Car</span>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="st_plugin_for"
                          value="Bus"
                          checked={
                            this.state.st_plugin_for == "Bus" ? "checked" : ""
                          }
                        />
                        <span>Bus</span>
                      </div>
                     
                    

                      <div className="form-group">
                        <label>Plugin Landing Page</label>
                        <br />
                        <Select
                          name="landing_page"
                          value={lang.common.landingPageOptions.find(
                            (option) => option.value === this.state.landing_page
                          )}
                          options={lang.common.landingPageOptions}
                          onChange={this.handleLandingPageChange}
                        />
                      </div>

                      

                      
                    </div>
                    
                    <div className="form-right">
                      <div className="form-group">
                        <label>Notification Popup Theme: </label>
                        <br />
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="np_theme"
                          value="Black"
                          checked={
                            this.state.np_theme == "Black" ? "checked" : ""
                          }
                        />
                        <span>Black bg with White text</span>
                        <br />
                        <br />
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="np_theme"
                          value="White"
                          checked={
                            this.state.np_theme == "White" ? "checked" : ""
                          }
                        />
                        <span>White bg with Black text</span>
                      </div>  
                        <br />
                          <div className="form-group">
                        <input
                          onChange={this.handleInputChange}
                          type="checkbox"
                          name="st_outer_space"
                          checked={this.state.st_outer_space_checked}
                        />
                        <label>Plugin outer space in mobile </label>
                      </div>

                      {/* <div className="form-group">
						<label>Plugin Size: </label>
					    <input onChange={this.handleInputChange} type="radio" name="plugin_size" value="600" checked={(this.state.plugin_size == "600" ? "checked" : "" )}/>
		                <span>600px</span>
		                 <input onChange={this.handleInputChange} type="radio"  name="plugin_size" value="700" checked={(this.state.plugin_size == "700" ? "checked" : "" )}/>
		                <span>700px</span>
 					</div>  */}
                    
                      <div className="form-group">
                        <label>Plugin Size </label>
                        <Select
                          options={pluginSizeDetails}
                          value={
                            selPluginSize
                              ? selPluginSize
                              : { value: "600", label: "600" }
                          }
                          onChange={this.handleChange.bind(this, "plugin_size")}
                          placeholder="Select plugin size"
                        />
                        <div className="errorpluginsize"></div>
                      </div>
                     
                       
                      
                      {/* <div className="form-group">
						<label>Product Layout: </label>
					    <input onChange={this.handleInputChange} type="radio" name="product_layout" checked={this.state.product_layout2_checked}/>
		                <span>2 Layout</span>
		                 <input onChange={this.handleInputChange} type="radio"  name="product_layout" checked={this.state.product_layout3_checked}/>
		                <span>3 Layout</span>
 					</div> 

					 <div className="form-group">
						<label>Header category limit: </label>
						<input type="number" className="form-control" name="header_cat_limit"  onChange={this.handleInputChange} value={this.state.header_cat_limit}/>
						
					</div> */}
                    </div>
                  </div>
                   <div className ="form-row">
                           <div className="form-left">
                          <div className="form-group">
						              <label>Notification maximum heigth (Upto 700 px): </label>
					    						<input type="number" className="form-control" name="st_notif_max_height"  onChange={this.handleInputChange} value={this.state.st_notif_max_height}/>
 					             </div>
                      </div>
                       
                        <div className="form-right">
                          <div className="form-group">
                            <label>Page title bottom spacing: </label>
                            <input type="number" className="form-control" name="st_page_title_btm_space"  onChange={this.handleInputChange} value={this.state.st_page_title_btm_space}/>
                        </div> 
                        </div> 
                    </div>
                     
                  <div className="title"><h4>Scaler Icon Management</h4></div>
             
				<div className="form-row">			
					<div className="form-left">	
            	<div className="form-group">
						<label>Max width (px):</label>
						<input type="number" className="form-control" name="st_scalar_width"  onChange={this.handleInputChange} value={this.state.st_scalar_width}/>
						<div className="errorscalarwidth"></div>
					</div>
						<div className="form-group">
						<label>Upload Scaler Icon</label>
						<div className="choose-file">
							{this.state.isHidden && <div className="image_success"></div>}
							<span className="profile_btn"><input type="file" name="scalar_icon_image" onChange={this.onChangeHandler.bind(this,'scalar_icon')} /></span>
						</div>
             {this.state.scalar_icon_preview!='' ?
                <div className="image-preview">
                  <img src={this.state.scalar_icon_preview} alt="Preview" className='img_class' />
                </div>		
              :  <div className="image-preview">
                  <img src={mediaUrl+'others/'+this.state.old_scalar_img} alt="" width="120"/>
                  </div>}	
						{/* {scalar_icon_preview} */}
            
						<div className="errorscalarimage"></div>
					</div>
				</div>
				<div className="form-right">
				
					<div className="form-group">
						<label>Max height (px):</label>
						<input type="number" className="form-control" name="st_scalar_height"  onChange={this.handleInputChange} value={this.state.st_scalar_height}/>
						<div className="errorscalarheight"></div>
					</div>
				</div>

				</div>

                  <div className="form-group">
                    <label>Terms & Conditions</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={this.state.st_term_conditions || ''}
                      onReady={(editor) => {
                        // You can store the "editor" and use when it is needed.
                      }}
                      name="st_term_conditions"
                      // onChange={this.handleInputChange}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        this.setState({ st_term_conditions: data });
                      }}
                    />
                    <div className="errorst_term_conditions"></div>                        
                  </div>

                  {/* <div className="title">
                    <h4>Ai Screen Management</h4>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Sidebar Expended size (px):</label>
                        <input
                          type="text"
                          className="form-control"
                          name="ai_side_menu_width"
                          onChange={this.handleInputChange}
                          value={this.state.ai_side_menu_width}
                        />
                        <div className="errorsai_side_menu_width"></div>
                      </div>

                      <div className="form-group">
                        <label>Sidebar Icon Size (px):</label>
                        <input
                          type="text"
                          className="form-control"
                          name="st_aisidebar_icon_width"
                          onChange={this.handleInputChange}
                          value={this.state.st_aisidebar_icon_width}
                        />
                        <div className="errorsst_aisidebar_icon_width"></div>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <label>Sidebar Collapsed size (px):</label>
                        <input
                          type="text"
                          className="form-control"
                          name="st_aisidebar_collapsed_width"
                          onChange={this.handleInputChange}
                          value={this.state.st_aisidebar_collapsed_width}
                        />
                        <div className="errorsst_aisidebar_collapsed_width"></div>
                      </div>
                    </div>
                  </div> */}
                  
                  {/* Inviting Screen start */}
                  <div className="title mt-5 pt-3">
                     <h4>Invite Screen Settings</h4>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Title</label>
                        <input
                          type="text"
                          className="form-control"
                          name="invitePageTitle"
                          onChange={this.handleInputChange}
                          value={this.state.invitePageTitle}
                        />
                        <div className="errorinvitePageTitle"></div>
                      </div> 

                        <div className="form-group">					
                        <label>Upload Image</label>
                        <input type="file" name="invitePageImg" onChange={this.onChangeHandler.bind(this, 'invitePageImg')} />
                        {this.state.invitePageImgPreview && (
                          <div className="image-preview">
                            <img src={this.state.invitePageImgPreview} alt="Preview" className='img_class' />
                          </div>		
                        )}	
                      </div>	
                      {this.state.invitePageImg ? 
                        <div className="form-group">
                          <a className="thumbnail" href="javascript:;" title="">
                            <img className="img-responsive common_delete_image" width="100" src={mediaUrl+'invitation/'+this.state.invitePageImg} />
                          </a>
                        </div>
                      : ''}
                                   
                    </div>
                    <div className="form-right">
                        <div className="form-group">
                        <label>Description</label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={this.state.invitePageDesc || ''}
                          onReady={(editor) => {
                            console.log("Editor is ready to use!", editor);
                          }}
                          name="invitePageDesc"
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({ invitePageDesc: data });
                          }}
                        />
                        <div className="errorinvitePageDesc"></div>
                      </div>    
                    
                    </div>
                                     
                  </div>
                  {/* Inviting Screen end */}

                  <div className="title mt-5 pt-3">
                     <h4>Plugin Invite Points</h4>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Point for inviting user</label>
                        <input
                          type="number"
                          className="form-control"
                          name="point_for_inviting_user"
                          onChange={this.handleInputChange}
                          value={this.state.point_for_inviting_user}
                        />
                        <div className="errorsettings_point_for_inviting_user"></div>
                    </div>
                     <div className="form-group">
                        <label>Point for inviting company</label>
                        <input
                          type="number"
                          className="form-control"
                          name="point_for_inviting_company"
                          onChange={this.handleInputChange}
                          value={this.state.point_for_inviting_company}
                        />
                        <div className="errorsettings_point_for_inviting_company"></div>
                      </div>

                    
                    </div>
                    <div className="form-right">
                       <div className="form-group">
                        <label>Point for inviting driver</label>
                        <input
                          type="number"
                          className="form-control"
                          name="point_for_inviting_driver"
                          onChange={this.handleInputChange}
                          value={this.state.point_for_inviting_driver}
                        />
                        <div className="errorsettings_point_for_inviting_driver"></div>
                      </div>
                    </div>
                    
                    <div className="form-right">
                      <div className="form-group">
                        <label>Invite Summary</label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={this.state.invite_summary || ''}
                          onReady={(editor) => {
                            console.log("Editor is ready to use!", editor);
                          }}
                          name="invite_summary"
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({ invite_summary: data });
                          }}
                        />
                        <div className="errorsettings_invite_summary"></div>
                      </div>
                    </div>
                    
                    <div className="form-right">
                      <div className="form-group">
                        <label>User Reward Summary</label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={this.state.user_invite_summary || ''}
                          onReady={(editor) => {
                            console.log("Editor is ready to use!", editor);
                          }}
                          name="user_invite_summary"
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({ user_invite_summary: data });
                          }}
                        />
                        {/* <textarea
                          className="form-control"
                          name="user_invite_summary"
                          onChange={this.handleInputChange}
                          value={this.state.user_invite_summary}
                        /> */}
                        <div className="errorsettings_user_invite_summary"></div>
                      </div>
                    </div>
                    
                     <div className="form-right">
                      <div className="form-group">
                        <label>Driver Reward Summary</label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={this.state.driver_invite_summary || ''}
                          onReady={(editor) => {
                            console.log("Editor is ready to use!", editor);
                          }}
                          name="driver_invite_summary"
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({ driver_invite_summary: data });
                          }}
                        />
                        <div className="errorsettings_driver_invite_summary"></div>
                      </div>
                    </div>

                     <div className="form-right">
                      <div className="form-group">
                        <label>Company Reward Summary</label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={this.state.company_invite_summary || ''}
                          onReady={(editor) => {
                            console.log("Editor is ready to use!", editor);
                          }}
                          name="company_invite_summary"
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({ company_invite_summary: data });
                          }}
                        />
                        <div className="errorsettings_company_invite_summary"></div>
                      </div>
                    </div>
                        <div className="form-left">
                      <div className="form-group">
                        <label>Credit Point Benifits</label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={this.state.credit_point_benefits || ''}
                          onReady={(editor) => {
                            console.log("Editor is ready to use!", editor);
                          }}
                          name="credit_point_benefits"
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({ credit_point_benefits: data });
                          }}
                        />
                        <div className="errorsettings_credit_point_benefits"></div>
                      </div>
                    </div>
                    
                     
                  </div>

                  <div className="title">
                    <h4>Commission for Plugin Owner</h4>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Standalone Ride Commission
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="standalone_ride_commission"
                          onChange={this.handleInputChange}
                          value={this.state.standalone_ride_commission}
                        />
                        <div className="errorstandalone_ride_commission"></div>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <label>
                          Company Ride Commission
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="company_created_ride_commission"
                          onChange={this.handleInputChange}
                          value={this.state.company_created_ride_commission}
                        />
                        <div className="errorcompany_created_ride_commission"></div>
                      </div>
                    </div>
                  </div>

                  <div className="title">
                    <h4>Bonus Reward Management</h4>
                  </div>

                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Are you provide reward bonus? </label>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="bonus_provide"
                          checked={this.state.st_bonus_provide_checked}
                        />
                        <span>Yes</span>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="bonus_provide"
                          checked={
                            this.state.st_bonus_provide_checked == false
                              ? "checked"
                              : ""
                          }
                        />
                        <span>No</span>
                      </div>
                    </div>
                    {/* <div className="form-right">					
					<div className="form-group">					
						<label>Bonus End Date<span class="required" style={{ color: "red" }} >* </span></label>
						<input type="text" className="form-control" name="company_created_ride_commission"  onChange={this.handleInputChange}  value={this.state.company_created_ride_commission} />
						<div className="errorcompany_created_ride_commission"></div>
					</div>		
				</div>	 */}
                  </div>

                  <div className="title">
                    <h4>Stripe Configuration</h4>
                  </div>
                  <div className="form-group">
                    <input
                      onChange={this.handleInputChange}
                      type="radio"
                      name="settings_enable_live"
                      checked={this.state.stripe_live_checked}
                    />
                    <span>Live</span>
                    <input
                      onChange={this.handleInputChange}
                      type="radio"
                      name="settings_enable_sandbox"
                      checked={this.state.stripe_sandbox_checked}
                    />
                    <span>SandBox</span>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Public Key
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="settings_public_key"
                          onChange={this.handleInputChange}
                          value={this.state.settings_public_key}
                        />
                        <div className="errorsettings_public_key"></div>
                      </div>

                      <div className="form-group">
                        <label>Product Key</label>
                        <input
                          type="text"
                          className="form-control"
                          name="settings_product_key"
                          onChange={this.handleInputChange}
                          value={this.state.settings_product_key}
                        />
                        <div className="errorsettings_product_key"></div>
                        <span>
                          Note : For Recurring payment(Monthly) the product key
                          use.
                        </span>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <label>
                          Secret Key
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          name="settings_secret_key"
                          onChange={this.handleInputChange}
                          value={this.state.settings_secret_key}
                        />
                        <div className="errorsettings_secret_key"></div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="title">
                    <h4>Shadow Management</h4>
                  </div>
                  <div className="form-row">
                    {Object.entries(this.state.shadows).map(([key, value]) => (
                      <div className="form-left" key={key}>
                        <div className="form-group admin-panel-btn">
                          <label>{this.labelFor(key)}:</label>
                          <input
                            value={value}
                            type="text"
                            autoComplete="off"
                            className="form-control"
                            style={{ width: "85%" }}
                            onChange={(e) =>
                              this.handleInputChangeShadows(key, e.target.value)
                            }
                          />
                          <button
                            type="button"
                            onClick={() => this.confirmPopup(key)}
                            style={{
                              color: "white",
                              padding: "14px",
                              minWidth: "47px",
                              height: "48px",
                              backgroundColor: "rgb(5, 31, 58)",
                              borderRadius: "0px 5px 5px 0px",
                            }}
                          >
                            <i>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#fff"
                                viewBox="32 -0.03 543.87 512.03"
                              >
                                <path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path>
                              </svg>
                            </i>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div> */}

                  {/* <div className="form-row">
                    <div className="input-popup-action">
                      <a
                        className="popup-close position-absolute cursor-pointer"
                        onClick={this.handleCancel}
                      >
                        X
                      </a>
                      <div className="title">
                        <h4>{this.labelFor(this.state.activeShadowType)}</h4>
                      </div>

                      <div className="shadow-picker-container d-flex w-100 justify-content-between">
                        <ShadowPicker
                          value={
                            this.state.shadows[this.state.activeShadowType] ||
                            ""
                          }
                          onChange={(value) => this.handleShadowChange(value)}
                          className="shadow-picker"
                        />

                        <div
                          className="shadow-box"
                          style={{
                            boxShadow:
                              this.state.shadows[this.state.activeShadowType] ||
                              "none",
                          }}
                        ></div>
                      </div>
                      <div className="d-flex w-100 justify-content-end gap-2 mt-5">
                        <a className="primary-btn" onClick={this.handleSubmit}>
                          Save
                        </a>
                      </div>
                    </div> */}

                    {/* <div className='shadow-picker-container d-flex w-100 justify-content-between'>
						<ShadowPicker
						value={this.state.shadow}
						onChange={(value) => {
							this.setState({shadow : value});
						}}
						className='shadow-picker'
						/>
						
						<div className='shadow-box' style={{boxShadow: this.state.shadow}}>
						</div>
					</div> */}

                    {/* <div className='d-flex w-100 justify-content-center gap-2 mt-5'>
						<button className='shadow-btn' onClick={this.handleSubmit}>Submit</button>
						<button className='shadow-btn' onClick={this.handleCancel}>cancel</button>
						
					</div> */}

                    {/* <div className="form-left">		
					<div className="form-group admin-panel-btn">
						<label>Shorcut menu Shadow: </label>
						<input  value={this.state.inputValue} type="text" name="domain_name" autocomplete="off" class="form-control"  style={{width: "85%"}} />
						<button onClick={this.confirmPopup} type="button" style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button>
					</div> 
				</div>  */}
                  {/* </div> */}

                  {/* Radius Managment Starts Here */}
                  {/* <div className="title">
                    <h4>Radius Management</h4>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Plugin Radius:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="st_plugin_radius"
                          onChange={this.handleInputChange}
                          value={this.state.st_plugin_radius}
                        />
                        <div className="errorst_plugin_radius"></div>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <label>
                          Dropdown Menu Radius (Bell notification, Group menu in
                          listing screen, Address dropdown):
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="st_dropdown_menu_radius"
                          onChange={this.handleInputChange}
                          value={this.state.st_dropdown_menu_radius}
                        />
                        <div className="errorst_dropdown_menu_radius"></div>
                      </div>
                    </div>
                  </div> */}
                  {/* Radius Managment Ends Here */}

                  {/* <div className="title">
                    <h4>Font Management</h4>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>Line Height</label>
                        <input
                          type="text"
                          className="form-control"
                          name="lineHeight"
                          onChange={this.handleInputChange}
                          value={this.state.lineHeight}
                        />
                        <div className="errorlineHeight"></div>
                      </div>
                    </div> */}
                    {/* <div className="form-left">
					<div className="default-font">
						<div className="form-group">
							<label>Font:</label>
							<Select 
								options={fonts}  
								value={selectedFont?selectedFont:{ value: '0', label: 'Select Font Type' }}
								onChange={this.handleChangeFont}
								placeholder="Select Font Type" />
							<div className="errorfont"></div>
						</div>
						<div className={this.state.selectedFontVariant != '' ? "show-font-type form-group":"hide-font-type form-group"} >
							<label>Font Variant:</label>
							{this.state.selectedFontVariant}
						</div>
					</div> 
					<div className="form-group">
						<label>Primary Font Size<span class="required" style={{ color: "red" }} > * </span></label>
						<input type="text" className="form-control" name="primary_font" onChange={this.handleInputChange}  value={this.state.primary_font}/>
						<div className="errorprimary_font"></div>
						
					</div>
				</div> */}

                    {/* <div className="form-right">	
					<div className="form-group">
						<label>Main Tab Font Size <span class="required" style={{ color: "red" }} > * </span></label>
						<input type="text" className="form-control" name="main_tab_font_size" onChange={this.handleInputChange}  value={this.state.main_tab_font_size}/>
						<div className="errormain_tab_font_size"></div>
					</div>
					<div className="form-group">
						<label>Menu Font Size<span class="required" style={{ color: "red" }} > * </span></label>
						<input type="text" className="form-control" name="menu_font_size" onChange={this.handleInputChange}  value={this.state.menu_font_size}/>
						<div className="errormenu_font_size"></div>					
					</div>
				</div>	 */}
                  {/* </div> */}

                  {/* {this.addMoreFunc()} */}

                  <div className="title">
                    <h4>Vehicle Management</h4>
                  </div> 
                  {/* <div className="form-row">		
                    <div className="form-left">
                      <div className="default-font">
                        <div className="form-group">
                          <label>Vechile Icon Size (Maximum Size: 20px)</label>
                          <input type="text" className="form-control" name="vechile_icon_size" onChange={this.handleInputChange}  value={this.state.vechile_icon_size}/>
                          <div className="errorvechile_size"></div>
                        </div>
                      </div> 
                    </div>                      
                  </div>	 */}
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Image Width (px)                          
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="st_vehicle_img_width"
                          onChange={this.handleInputChange}
                          value={this.state.st_vehicle_img_width}
                        />
                        <div className="errorst_vehicle_img_width"></div>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <label>
                          Image Height (px)                          
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="st_vehicle_img_height"
                          onChange={this.handleInputChange}
                          value={this.state.st_vehicle_img_height}
                        />
                        <div className="errorst_vehicle_img_height"></div>
                      </div>
                    </div>
                  </div>
                  {/* Price Management Start */}
                  <div className="title">
                    <h4>Price Management</h4>
                  </div>                 
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Booking Fee ($)                       
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="rideBookingFee"
                          onChange={this.handleInputChange}
                          value={this.state.rideBookingFee}
                        />
                        <div className="errorrideBookingFee"></div>
                      </div>  
                       <div className="form-group">
                        <label>
                          Toll Charge ($)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="tollCharge"
                          onChange={this.handleInputChange}
                          value={this.state.tollCharge}
                        />
                        <div className="errortollCharge"></div>
                      </div>                   
                    </div>
                   <div className="form-right">
                      <div className="form-group">
                        <label>Payment Information</label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={this.state.payment_info || ''}
                          onReady={(editor) => {
                            console.log("Editor is ready to use!", editor);
                          }}
                          name="payment_info"
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({ payment_info: data });
                          }}
                        />
                        <div className="errorsettings_payment_info"></div>
                      </div>
                    </div>
                  </div>
                  {/* Price Management End */}

                  <div class="title"><h4>Local Ride Price Management</h4></div>

						      <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">					
                        <label>Base price:</label>
                        <input type="text" name="localRideBasePrice" onChange={this.handleInputChange} className="form-control" value={this.state.localRideBasePrice} />
                        <div className="errorlocalRideBasePrice"></div>
                      </div>
                      <div className="form-group">
                        <label>Ride charges (per minute): </label>
                        <input type="text" name="localRidePerMin" onChange={this.handleInputChange} className="form-group" value={this.state.localRidePerMin} />
                      </div>
                      <div className="form-group">					
                        <label>Stop fee:</label>
                        <input type="text" name="localRideStopfee" onChange={this.handleInputChange} className="form-control" value={this.state.localRideStopfee} />
                        <div className="errorlocalRideStopfee"></div>
                      </div>   
                  </div>
                  <div className="form-right">
                        <div className="form-group">
                        <label>Max miles: </label>
                        <input type="text" name="localRideMaxMile" onChange={this.handleInputChange} className="form-group" value={this.state.localRideMaxMile} />
                      </div>
                      <div className="form-group">
                        <label>Ride charges (per mile): </label>
                        <input type="text" name="localRidePerMile" onChange={this.handleInputChange} className="form-group" value={this.state.localRidePerMile} />
                      </div>
                      
                  </div>
                </div>

						    <div class="title"><h4>Medium Ride Price Management</h4></div>

                <div className="form-row">
                  <div className="form-left">
                      <div className="form-group">					
                      <label>Base price:</label>
                        <input type="text" name="mediumRideBasePrice" onChange={this.handleInputChange} className="form-control" value={this.state.mediumRideBasePrice} />
                      <div className="errormediumRideBasePrice"></div>
                      </div>
                      <div className="form-group">
                        <label>Ride charges (per minute): </label>
                        <input type="text" name="mediumRidePerMin" onChange={this.handleInputChange} className="form-group" value={this.state.mediumRidePerMin} />
                      </div>
                      <div className="form-group">					
                        <label>Stop fee:</label>
                        <input type="text" name="mediumRideStopfee" onChange={this.handleInputChange} className="form-control" value={this.state.mediumRideStopfee} />
                        <div className="errormediumRideStopfee"></div>
                      </div>
                      
                  </div>
                  <div className="form-right">
                        <div className="form-group">
                        <label>Max miles: </label>
                        <input type="text" name="mediumRideMaxMiles" onChange={this.handleInputChange} className="form-group" value={this.state.mediumRideMaxMiles} />
                      </div>
                      <div className="form-group">
                        <label>Ride charges (per mile): </label>
                        <input type="text" name="mediumRidePerMile" onChange={this.handleInputChange} className="form-group" value={this.state.mediumRidePerMile} />
                      </div>
                      
                      
                  </div>
                </div>

						    <div class="title"><h4>Long Ride Price Management</h4></div>

						<div className="form-row">
							<div className="form-left">
									<div className="form-group">					
									<label>Base price:</label>
										<input type="text" name="longRideBasePrice" onChange={this.handleInputChange} className="form-control" value={this.state.longRideBasePrice} />
									<div className="errorlongRideBasePrice"></div>
									</div>
									<div className="form-group">
										<label>Ride charges (per minute): </label>
										<input type="text" name="longRidePerMin" onChange={this.handleInputChange} className="form-group" value={this.state.longRidePerMin} />
									</div>
									<div className="form-group">					
                      <label>Stop fee:</label>
                      <input type="text" name="longRideStopfee" onChange={this.handleInputChange} className="form-control" value={this.state.longRideStopfee} />
                      <div className="errorlongRideStopfee"></div>
                  </div>
							</div>
							<div className="form-right">
								    <div className="form-group">
										<label>Max miles: </label>
										<input type="text" name="longRideMaxMiles" onChange={this.handleInputChange} className="form-group" value={this.state.longRideMaxMiles} />
									</div>
									<div className="form-group">
										<label>Ride charges (per mile): </label>
										<input type="text" name="longRidePerMile" onChange={this.handleInputChange} className="form-group" value={this.state.longRidePerMile} />
									</div>
                  
							</div>
						</div>

						<div class="title"><h4>Ultra Long Ride Price Management</h4></div>

						<div className="form-row">
							<div className="form-left">
									<div className="form-group">					
									<label>Base Price:</label>
										<input type="text" name="ultraLongRideBasePrice" onChange={this.handleInputChange} className="form-control" value={this.state.ultraLongRideBasePrice} />
									<div className="errorultraLongRideBasePrice"></div>
									</div>
									<div className="form-group">
										<label>Ride charges (per minute): </label>
										<input type="text" name="ultraLongRidePerMin" onChange={this.handleInputChange} className="form-group" value={this.state.ultraLongRidePerMin} />
									</div>
                  <div className="form-group">					
                      <label>Stop fee:</label>
                      <input type="text" name="ultraLongRideStopfee" onChange={this.handleInputChange} className="form-control" value={this.state.ultraLongRideStopfee} />
                      <div className="errorultraLongRideStopfee"></div>
                  </div>
									
							</div>
							<div className="form-right">
								<div className="form-group">
									<label>Miles exceeding limit: </label>
									<input type="text" name="ultraLongRideMaxMiles" onChange={this.handleInputChange} className="form-group" value={this.state.ultraLongRideMaxMiles} />
								</div>
								<div className="form-group">
									<label>Ride charges (per mile): </label>
									<input type="text" name="ultraLongRidePerMile" onChange={this.handleInputChange} className="form-group" value={this.state.ultraLongRidePerMile} />
								</div>	
							</div>
						</div>

            	<div class="title"><h4>Extra Price Management</h4></div>

              <div className="form-row">
                <div className="form-left">
                  
                    <div className="form-group">					
                    <label>Extra free minutes:</label>
                      <input type="text" name="extraUptoMins" onChange={this.handleInputChange} className="form-control" value={this.state.extraUptoMins} />
                    <div className="errorextraUptoMins"></div>
                    </div>
                    <div className="form-group">
                      <label>Extra Minute Charge (per minute): </label>
                      <input type="text" name="extraPerMinCost" onChange={this.handleInputChange} className="form-group" value={this.state.extraPerMinCost} />
                        <div className="errorextraPerMinCost"></div>
                    </div>
                    
                    
                </div>
                <div className="form-right">
                  <div className="form-group">					
                        <label>Extra mile charge (per mile):</label>
                        <input type="text" name="extraPerMileCost" onChange={this.handleInputChange} className="form-control" value={this.state.extraPerMileCost} />
                        <div className="errorextraPerMileCost"></div>
                    </div>
                  <div className="form-group">
                    <br/><br/>
                    <input
                      onChange={this.handleInputChange}
                      type="checkbox"
                      name="extraChargesTestMode"
                      checked={this.state.extraChargesTestMode}
                    />
                    <label>Test mode (Extra 1hr and 20 miles added)</label>
                  </div>
                </div>
              </div>
                 
                  {/* Base Price Management End */}
                  
                  {/* Cost Management Start */}
                  <div className="title">
                    <h4>Cost Management</h4>
                  </div>                 
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Bank A/C Verification Range Amount ($)                          
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="bankAccVerifyAmt"
                          onChange={this.handleInputChange}
                          value={this.state.bankAccVerifyAmt}
                        />
                        <div className="errorbankAccVerifyAmt"></div>
                      </div>
                    </div>
                  </div>
                  {/* Cost Management End */}

                     
                  {/* Credit Point Management Start */}
                  <div className="title">
                    <h4>Credit point management</h4>
                  </div>                 
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Credit points to cost ($)                          
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="creditAmountByDoller"
                          onChange={this.handleInputChange}
                          value={this.state.creditAmountByDoller}
                        />
                        <div className="errorcreditAmountByDoller"></div>
                      </div>
                    </div>
                     <div className="form-right">
                      <div className="form-group">
                        <label>
                          Earn Credit Points While Registering                      
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="earnedCreditPoint"
                          onChange={this.handleInputChange}
                          value={this.state.earnedCreditPoint}
                        />
                        <div className="errorearnedCreditPoint"></div>
                      </div>
                    </div>
                  </div>
                   <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Earn Points Unit                   
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="convertAmtToPoints"
                          onChange={this.handleInputChange}
                          value={this.state.convertAmtToPoints}
                        />
                        <div className="errorconvertAmtToPoints"></div>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <label>
                          Custom Range Bonus Points (%)                        
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="extraCreditPoint"
                          onChange={this.handleInputChange}
                          value={this.state.extraCreditPoint}
                        />
                        <div className="errorextraCreditPoint"></div>
                      </div>
                    </div>
                     
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Credit points for airport pickup or airport drop-off                
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="airport_either_pts"
                          onChange={this.handleInputChange}
                          value={this.state.airport_either_pts}
                        />
                        <div className="errorairport_either_pts"></div>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <label>
                         Credit points for airport pickup and airport drop-off                  
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="airport_both_pts"
                          onChange={this.handleInputChange}
                          value={this.state.airport_both_pts}
                        />
                        <div className="errorairport_both_pts"></div>
                      </div>
                    </div>
                     
                  </div>
                  {/* Credit Point Management End */}
                  {/* Ride Management Start */}
                   <div className="title">
                    <h4>Ride Management</h4>
                  </div> 
                    <div className="form-row">
                      <div className="form-left">
                        <div className="form-group">
                          <label>
                            Edit Ride Time Limit (mins)                      
                          </label>
                
                          <Select 
                            name="editRideTimeLimit"
                            id="editRideTimeLimit"
                            options={lang.common.mins_option}
                            value={editRideTimeLimitSel?editRideTimeLimitSel:{ value: '05', label: '05' }}
                            onChange={this.handleOnDropChange.bind(this, 'editRideTimeLimit')}
                            placeholder="&nbsp;"
                          />
                          <div className="erroreditRideTimeLimit"></div>
                        </div>
                      </div> 
                      <div className="form-right">
                        <div className="form-group">
                        <label>Common ride information</label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={this.state.common_ride_info || ''}
                          onReady={(editor) => {
                            console.log("Editor is ready to use!", editor);
                          }}
                          name="common_ride_info"
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({ common_ride_info: data });
                          }}
                        />
                        <div className="errorsettings_common_ride_info"></div>
                      </div>
                      </div>
                    <div>
                      
                    </div>                   
                  </div>
                  {/* Ride Management End */}

                  <div className="title">
                    <h4>Start Ride Settings</h4>
                  </div> 
                    <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Advance time of scheduled ride (in mins)                       
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="driver_before_grace_time"
                          onChange={this.handleInputChange}
                          value={this.state.driver_before_grace_time}
                        />
                        <div className="errordriver_before_grace_time"></div>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <label>
                          Grace time of scheduled ride (in mins)                   
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="driver_after_grace_time"
                          onChange={this.handleInputChange}
                          value={this.state.driver_after_grace_time}
                        />
                        <div className="errordriver_after_grace_time"></div>
                      </div>
                    </div>
                  </div>

                   {/* Cancel Ride Management Start */}
                  <div className="title">
                    <h4>Cancel Ride Management</h4>
                  </div>                 
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Cancellation Hours                       
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="cancellationHours"
                          onChange={this.handleInputChange}
                          value={this.state.cancellationHours}
                        />
                        <div className="errorcancellationHours"></div>
                      </div>
                      <div className="form-group">
                        <label>
                          Cancellation Charges 
                          {this.state.cancellationChargeType == 'Percentage' ? ' (%)' : ' ($)'}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="cancellationChargeAmt"
                          onChange={this.handleInputChange}
                          value={this.state.cancellationChargeAmt}
                        />
                        <div className="errorcancellationChargeAmt"></div>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <label>
                          Charge Type
                        </label>
                        <Select 
                          name="cancellationChargeType"
                          id="cancellationChargeType"
                          options={lang.common.discount_type}
                          value={this.state.cancellationChargeTypeSel?this.state.cancellationChargeTypeSel:{ value: 'Flat', label: 'Flat'}}
                          onChange={this.handleOnDropChange.bind(this, 'cancellationChargeType')}
                          placeholder="&nbsp;"
                        />
                        <div className="errorcancellationChargeType"></div>
                      </div>
                    </div>
                  </div>
                  {/* Cancel Ride Management End */}
                   {/* Block driver Management Start */}
                  <div className="title">
                    <h4>Block Driver Management</h4>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Number of Ride Cancellations to Block                       
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="driver_cancel_block_limit"
                          onChange={this.handleInputChange}
                          value={this.state.driver_cancel_block_limit}
                        />
                        <div className="error_driver_cancel_block_limit"></div>
                      </div>
                    </div>
                  </div>

                  {/* Datafeedr Management Start */}
                  <div className="title">
                    <h4>Datafeedr Management</h4>
                  </div>
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Keyword (Travel | Car accessories)
                        </label>
              
                        <input
                          type="text"
                          className="form-control"
                          name="datafeedrCategory"
                          onChange={this.handleInputChange}
                          value={this.state.datafeedrCategory}
                        />
                        <div className="errordatafeedrCategory"></div>
                      </div>
                    </div>
                  </div>
                  {/* Datafeedr Management End */}

                  <div className="title">
                    <h4>Flight Info </h4>
                  </div>                   
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Today Booking Timing
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <Select 
                          name="bookingTiming"
                          id="bookingTiming"
                          options={lang.common.timing_option}
                          value={bookingTimingSel?bookingTimingSel:{ value: '05', label: '+05' }}
                          onChange={this.handleOnDropChange.bind(this, 'bookingTiming')}
                          placeholder="&nbsp;"
                        />
                        <div className="errorbookingTiming"></div>
                      </div>
                      <div className="form-group">
                        <label>
                          International Flight Timing
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>  
                        </label>
                        <Select 
                          name="internationalFlightTiming"
                          id="internationalFlightTiming"
                          options={lang.common.timing_option}
                          value={internationalFlightTimingSel?internationalFlightTimingSel:{ value: '05', label: '05' }}
                          onChange={this.handleOnDropChange.bind(this, 'internationalFlightTiming')}
                          placeholder="&nbsp;"
                        />
                        <div className="errorinternationalFlightTiming"></div>
                      </div>
                      <div className="form-group">
                        <label>
                          Domestic Flight Timing
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <Select 
                          name="domesticFlightTiming"
                          id="domesticFlightTiming"
                          options={lang.common.timing_option}
                          value={domesticTimingSel?domesticTimingSel:{ value: '05', label: '05' }}
                          onChange={this.handleOnDropChange.bind(this, 'domesticFlightTiming')}
                          placeholder="&nbsp;"
                        />
                        <div className="errordomesticFlightTiming"></div>
                      </div>
                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <label>
                          Today Booking Tooltip
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={this.state.bookingTimingTooltip || ''}
                          onReady={(editor) => {
                            //console.log("Editor is ready to use!", editor);
                          }}
                          name="bookingTimingTooltip"
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({ bookingTimingTooltip: data });
                          }}
                        />
                        <div className="error_bookingTimingTooltip"></div>
                      </div>
                      <div className="form-group">
                        <label>
                          International Flight Timing Tooltip
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={this.state.internationalFlightTimingTooltip || ''}
                          onReady={(editor) => {
                            //console.log("Editor is ready to use!", editor);
                          }}
                          name="internationalFlightTimingTooltip"
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({ internationalFlightTimingTooltip: data });
                          }}
                        />
                        <div className="error_internationalFlightTimingTooltip"></div>
                      </div>
                      <div className="form-group">
                        <label>
                          Domestic Flight Timing Tooltip
                          <span class="required" style={{ color: "red" }}>
                            *{" "}
                          </span>
                        </label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={this.state.domesticTimingTooltip || ''}
                          onReady={(editor) => {
                            //console.log("Editor is ready to use!", editor);
                          }}
                          name="domesticTimingTooltip"
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({ domesticTimingTooltip: data });
                          }}
                        />
                        <div className="error_domesticTimingTooltip"></div>
                      </div>
                    </div>
                  </div>

                  <div className="title">
                    <h4>Map Box Style Settings</h4>
                  </div> 
                  <div className="form-row">
                    <div className="form-left">
                      <div className="form-group">
                        <label>
                          Load Map Style                          
                        </label>
              
                        <input
                          type="url"
                          className="form-control"
                          name="st_load_map"
                          onChange={this.handleInputChange}
                          value={this.state.st_load_map}
                        />
                        <div className="errorst_load_map"></div>
                      </div>

                       <div className="form-group">
                        <label>
                          Route Map Style                          
                        </label>
              
                        <input
                          type="url"
                          className="form-control"
                          name="st_route_map"
                          onChange={this.handleInputChange}
                          value={this.state.st_route_map}
                        />
                        <div className="errorst_route_map"></div>
                      </div>

                       <div className="form-group">
                        <label>
                          Tracking Map Style                          
                        </label>
              
                        <input
                          type="url"
                          className="form-control"
                          name="st_tracking_map"
                          onChange={this.handleInputChange}
                          value={this.state.st_tracking_map}
                        />
                        <div className="errorst_tracking_map"></div>
                      </div>

                    </div>
                    <div className="form-right">
                      <div className="form-group">
                        <label>
                          Zoom                
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="st_load_map_zoom"
                          onChange={this.handleInputChange}
                          value={this.state.st_load_map_zoom}
                        />
                        <div className="errorst_load_map_zoom"></div>
                      </div>

                      <div className="form-group">
                        <label>
                          Zoom                
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="st_route_map_zoom"
                          onChange={this.handleInputChange}
                          value={this.state.st_route_map_zoom}
                        />
                        <div className="errorst_route_map_zoom"></div>
                      </div>

                      <div className="form-group">
                        <label>
                          Zoom                
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="st_tracking_map_zoom"
                          onChange={this.handleInputChange}
                          value={this.state.st_tracking_map_zoom}
                        />
                        <div className="errorst_tracking_map_zoom"></div>
                      </div>
                    </div>
                  </div>

                  <div className="title">
                          <h4>Theme Management</h4>
                        </div> 
                        
                        <div className="form-row">		
                          <div className="form-left">
                            <div className="default-font">
                              <div className="form-group">
                                <label>Theme :</label>
                                <Select 
                                  options={this.state.themeData}  
                                  value={selTheme?selTheme:{ value: '0', label: 'Select Theme' }}
                                  onChange={this.handleChangeTheme}
                                  placeholder="Select theme"
                                />
                                <div className="errortheme"></div>
                              </div>
                            </div> 
                          </div> 
                        </div>	
                      

                  <div className="btn-group export">
                    <button
                      className="btn btn_orange btn_minwid login_submit animate-btn2"
                      type="submit"
                      disabled={this.state.Loading === true ? true : false}
                    >
                      {" "}
                      {this.state.Loading === true && (
                        <span className="load-data">Loading</span>
                      )}{" "}
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Setting;
